/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import JSZip from 'jszip';
import download from 'js-file-download';
import {
  CustomGrid,
  CustomInfosForm,
  TextareaAutosize,
  BootstrapDialog
} from '../../../../assets/style/globalStyle';
import ContractIndicators from './ContractIndicators';
import { validateCNPJ, validateCPF, validEmail } from '../../../../@core/utils/utilsFunctions';
import { NotificationManager } from 'react-notifications';
import { DropzoneArea } from 'mui-file-dropzone';
import { useSelector } from 'react-redux';
import { selectLogin, selectClient } from '../../../../store/login/loginSlice';
import { isMobile } from 'react-device-detect';
import { useDebounce } from 'use-debounce';
import { useDispatch } from 'react-redux';
import {
  selectNotification,
  selectNotificationClient,
  client
} from '../../../../store/clients/clientsSlice';
import { formatDate, removeAccents, viaCNPJ } from '../../../../@core/utils/utilsFunctions';
import {
  Stack,
  Typography,
  Card,
  CardHeader,
  Button,
  TextField,
  Grid,
  Select,
  Menu,
  MenuItem,
  Autocomplete,
  InputLabel,
  InputAdornment,
  IconButton,
  Tab,
  Box,
  Badge,
  Alert,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  ListItemText
} from '@mui/material';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing,
  Selection
} from 'devextreme-react/data-grid';
import { startAndStop } from '../../../../store/loading/loadingSlice';
import configAxios from '../../../../services/configAxios';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import InputMask from 'react-input-mask';
import LockResetIcon from '@mui/icons-material/LockReset';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import useWebSocket from 'react-use-websocket';
import ReactShortcut from 'react-shortcut';
import Iconify from '../../../../@core/theme/Iconify';
import RenderPage from '../../../layouts/RenderPage';
import AddEditClientsDependents from './AddEditClientsDependents';
import DiscussionClients from './DiscussionClients';
import MessagesEntrevis from './MessagesEntrevis';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import MoreMenuDocuments from '../../../components/multiplesComponents/MoreMenuDocuments';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import SendEmailDocuments from './SendEmailDocuments';
import SendWelcome from './SendMailWelcome';
import SendWhatsAppDocuments from './SendWhatsAppDocuments';
import HistorySales from './HistorySales';
import IntegrationClients from './IntegrationClients';
import IntegrationClientsThird from './IntegrationClientsThird';
import IntegrationHealthMap from './IntegrationHealthMap';
import AddEditDeclarationHealth from '../signature/AddDeclarationHealth';
import DocumentsForSignature from '../signature/DocumentsForSignature';
import DownloadDocumentsSigning from '../signature/DownloadDocumentsSigning';
import AddEditAddress from './AddEditAddress';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import PendingHealthDeclaration from '../signature/PendingHealthDeclaration';
import MaintenanceClients from './MaintenanceClients';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import ShowDocuments from '../../../components/multiplesComponents/ShowDocuments';
import SchedulingClients from './SchedulingClients';
import AddEditClaims from './AddEditClaims';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DescriptionIcon from '@mui/icons-material/Description';

/**
 * id_type_client === 1 - Físico
 * id_type_client === 2 - Júridico
 *
 */

const AddEditClients = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { id: urlId } = useParams();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const allowedPageSizes = [5, 10, 20, 30];
  const dispatch = useDispatch();
  const [infosClients, setInfosClients] = useState(state ? { ...state.infosEdit } : {});
  const [initialInfosClients] = useState(state ? { ...state.infosEdit } : {});
  const [infosDeps, setInfosDeps] = useState([]);
  const [infosAddress, setInfosAddress] = useState([]);
  const [infosAdressEdit, setInfosAddressEdit] = useState({});
  const [infosDisabledStatusVenda] = useState([
    'Rejeitada',
    'Aguardando cliente',
    'Realizar entrevista',
    'Analisar entrevista',
    'Aguardando CPT(s)',
    'Aguardando corretora',
    'Aguardando operadora',
    'Aguardando administradora',
    'Aprovada',
    'Negada',
    'Cancelada pelo proponente'
  ]);

  const [infosDepsTit, setInfosDepsTit] = useState({});
  const [infosDepsEdit, setInfosDepEdit] = useState({});
  const [infosOrgaEmissor, setInfosOrgaEmissor] = useState([]);
  const [infosPlans, setInfosPlans] = useState([]);
  const [infosTables, setInfosTables] = useState([]);
  const [infosTablesTemp, setInfosTablesTemp] = useState([]);
  const [infosWaitingPeriod, setInfosWaitingPeriod] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddress, setOpenModalAddress] = useState(false);
  const [openModalDocumentUpload, setOpenModalDocumentUpload] = useState(false);
  const [openModalImportLayout, setOpenModalImportLayout] = useState(false);
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState([]);
  const [allBeneficiaries, setAllBeneficiaries] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [openModalDiscussions, setOpenModalDiscussion] = useState(false);
  const [openModalMessagesEntrevis, setOpenModalMessagesEntrevis] = useState(false);
  const [salesValue, setSalesValue] = useState(infosClients.valclient || '');
  const infoStateTemp = useSelector(selectLogin);
  const notification = useSelector(selectNotification);
  const selectNotificationsClient = useSelector(selectNotificationClient);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const infosClient = useSelector(selectClient);
  const [infoSelectVend, setInfoSelectVend] = useState([]);
  const [infosUploads, setInfosUploads] = useState([]);
  const [infosAssociations, setInfosAssociation] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const key = useRef('');
  const keyWhatsapp = useRef(1000);
  const [value] = useDebounce(key.current, 1000);
  const [valueWhatsApp] = useDebounce(keyWhatsapp.current, 2000);
  const keys = useRef(1);
  const keysMessageEntrevis = useRef(100);
  const [valueKeys] = useDebounce(keys.current, 1000);
  const [valueKeysEntrevis] = useDebounce(keysMessageEntrevis.current, 1000);
  const [values, setValues] = useState('1');
  const [countMessages, setCountMessages] = useState([]);
  const [countMessagesEntrevis, setCountMessagesEntrevis] = useState([]);
  const [countSigningDocuments, setCountSigningDocuments] = useState(
    infosClients.id && infoState.id_type_user === 1 ? 1 : 0
  );
  const [openModalSendEmailDocuments, setOpenModalSendEmailDocuments] = useState(false);
  const [openModalsendWelcome, setOpenModalsendWelcome] = useState(false);
  const [openModalSendWhatsAppDocuments, setOpenModalSendWhatsAppDocuments] = useState(false);
  const [openModalDownloadPdf, setOpenModalDownloadPdf] = useState(false);
  const [openSchedulingClientsModal, setOpenSchedulingClientsModal] = useState(false);
  const [downloadPdf, setDownloadPdf] = useState(null);
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalIntegration, setOpenModalIntegration] = useState(false);
  const [openModalIntegrationThird, setOpenModalIntegrationThird] = useState(false);
  const [openModalIntegrationHealthMap, setOpenModalIntegrationHealthMap] = useState(false);
  const [infosHistoryEmail, setInfosHistoryEmail] = useState([]);
  const [infosHistoryWhastApp, setInfosHistoryWhatsApp] = useState([]);
  const [infosHistorySales, setInfosHistorySales] = useState([]);
  const [infosHistoryHealthMap, setInfosHistoryHealthMap] = useState([]);
  const [infosHistoryIntegration, setHistoryIntegration] = useState([]);
  const [infosHistoryIntegrationThird, setHistoryIntegrationThird] = useState([]);
  const [resultIntegration, setResultIntegration] = useState([]);
  const [resultIntegrationThird, setResultIntegrationThird] = useState([]);
  const [infosContract, setInfosContract] = useState([]);
  const [imcCalculado, setImcCalculado] = useState({});
  const [rowSelected, setRowSelected] = useState();
  const [openModalDeclarationHealth, setOpenModalDeclarationHealth] = useState(false);
  const [showDeclaration, setShowDeclaration] = useState(false);
  const [infosQuestions, setInfosQuestions] = useState([]);
  const [responseQuestions, setResponseQuestions] = useState([]);
  const [openModalPendingHealth, setOpenModalPendingHealth] = useState(false);
  const [pendingInfosDeclarationHealth, setPendingInfosDeclarationHealth] = useState([]);
  const [headerModalPending, setHeaderModalPending] = useState('');
  const [openMaintenance, setOpenMaintenance] = useState(false);
  const [rowsSelected, setRowsSelected] = useState([]);
  const company = useSelector(selectClient);

  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [openModalIndicators, setOpenModalIndicators] = useState(false);
  const infosPJ = useRef({ statusvenda: '', nomefantasia: '', codclient: '' });
  const infosPF = useRef({ statusvenda: '', nome: '', codclient: '' });
  const [infosClientsHealth, setInfosClientsHealth] = useState([]);
  const [imcAlerta, setImcAlerta] = useState({ show: false, message: '' });
  const [parametrosAlerta, setParametrosAlerta] = useState({ show: false, message: '' });

  const [rowsSelectedDownload, setRowsDownload] = useState([]);
  const [documentsDownload, setDocumentsDownload] = useState([]);
  const [cpfBuscado, setCpfBuscado] = useState('');
  const [infosRegioes, setInfosRegioes] = useState([]);
  const [infosDaysTerms, setInfosDaysTerms] = useState([]);
  const [openModalClaims, setOpenModalClaims] = useState(false);
  const [infosClaims, setInfosClaims] = useState([]);
  const [openModalDeleteClaim, setOpenModalDeleteClaim] = useState(false);
  const [agravosMenuAnchor, setAgravosMenuAnchor] = useState(null);
  const [infosTypesOfHiring, setInfosTypesOfHiring] = useState([]);
  const [infosDocs, setInfosDocs] = useState([]);

  const [openModalPending, setOpenModalPending] = useState(false);
  const [pendingDocsList, setPendingDocsList] = useState([]);

  useEffect(() => {
    if (infosClients.cpf_cnpj) {
      setCpfBuscado(infosClients.cpf_cnpj);
    }
    if (infoState.controlaregiao === 'Sim') {
      getRegioes();
    }
    getDaysTerms(infosClients.tpcontrat, infosClients.id_regiao);
    getTypesOfHiring();
    getDocs();
  }, []);

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editClients' && !infosClients.id) {
      if (!urlId) {
        navigation('/app/clients');
        return;
      }

      configAxios
        .get(`/clients/getClientById/${urlId}`)
        .then((response) => {
          if (response.data && response.data.id) {
            Object.assign(initialInfosClients, response.data);
            setInfosClients({ ...response.data });
          } else {
            navigation('/app/clients');
          }
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar as informações do cliente, tente novamente!',
            'Atenção'
          );
          navigation('/app/clients');
        });
      return;
    }

    if (pathNameSplice[2] === 'addClients' && infoState.id_type_user !== 2)
      [navigation('/app/clients')];

    if (infosClients.tpcontrat_client !== '3-COLETIVO POR ADESAO') {
      getPlans(infosClients.tpcontrat_client);
      getTables();
    } else {
      getPlansAssociation(
        infosClients.id_association,
        infosClients.id_broker,
        infosClients.id_regiao
      );
      getTablesAssociation(infosClients.id_association);
    }

    if (infosClients.id) {
      setSalesValue(infosClients.valclient);

      if (infoState.entrevisqualificada === 'Sim') {
        getInfosclients();
      }

      if (infoState.solicitawhatsapp === 'Sim') {
        getHistoryWhatsApp();
      }

      Promise.all([
        getDependents(),
        getCountMessages(),
        getCountMessagesEntrevis(),
        getHistoryEmails(),
        getHistorySales(),
        getHistoryHealthMap(),
        getHistoryIntegration(),
        getHistoryIntegrationThird(),
        getAddress(),
        getCountDocumentsSigning()
      ]);

      if (infosClients.statusvenda === 'Aprovada') {
        getDocumentsDownload();
      }
    }

    if (
      infosClients.statusvenda === 'Aguardando corretora' ||
      infosClients.statusvenda === 'Aguardando operadora' ||
      infosClients.statusvenda === 'Aguardando administradora' ||
      infosClients.statusvenda === 'Realizar entrevista' ||
      infosClients.statusvenda === 'Analisar entrevista' ||
      infosClients.statusvenda === 'Aguardando CPT(s)' ||
      infosClients.statusvenda === 'Aprovada'
    ) {
      getInfosContract();
      getInfosQuestions();
    }

    Promise.all([
      getInfoSelectVend(),
      getInfosOrgaoEmissor(),
      getFilesUploads(),
      getWaitingPeriod(),
      getAssociations()
    ]);
  }, [infosClients.id]);

  useEffect(() => {
    if (Object.keys(selectNotificationsClient).length) {
      setInfosClients({ ...selectNotificationsClient });
      dispatch(client({}));
      keys.current = Math.random();
    }
  }, [notification]);

  // Verificar IMC quando beneficiários, perguntas e limite estiverem disponíveis
  useEffect(() => {
    if (infosContract.length > 0 && infosQuestions.length > 0 && infoState.imc_declinio) {
      checkIMCAllBeneficiaries(infosContract);
    }
  }, [infosContract, infosQuestions, infoState.imc_declinio]);

  // Verificar parâmetros de declínio
  useEffect(() => {
    if (infosClients.id && infosClients.tpcontrat_client) {
      checkParametrosDeclinio(infosContract || []);
    } else {
      setParametrosAlerta({ show: false, message: '' });
    }
  }, [
    infosContract,
    infoState.idade_declinio,
    infoState.minimo_vidas_empresarial,
    infoState.razao_dependencia_maxima,
    infosClients.id,
    infosClients.tpcontrat_client,
    infosClients.titbenef,
    infosClients.dtnascimento,
    infosClients.statusvenda
  ]);

  // Carregar beneficiários quando o modal de upload for aberto
  useEffect(() => {
    if (openModalDocumentUpload && infosClients.id) {
      // Combinar titular + dependentes para o modal de upload
      const titular = {
        id: infosClients.id,
        nome: infosClients.nome,
        cpf: infosClients.cpf_cnpj,
        parentesco: 'Titular',
        tpbenef: 'Titular'
      };

      const allBenefs = [titular, ...infosDeps];
      setAllBeneficiaries(allBenefs);
    }
  }, [
    openModalDocumentUpload,
    infosClients.id,
    infosClients.nome,
    infosClients.cpf_cnpj,
    infosDeps
  ]);

  function getDocs() {
    const router = '/docs/listDocs';
    configAxios
      .get(router)
      .then((result) => {
        setInfosDocs(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  const handleCloseModal = () => {
    setOpenModalPending(false);
  };

  const wsURL =
    process.env.NODE_ENV === 'production'
      ? 'wss://app.vendasplanoonline.com.br:3014'
      : 'ws://localhost:3014';

  /** parâmetros para disparar notificação entre operadora e entrevistador */
  let queryParamsOpAndEnt = {
    'x-access-token': infoStateTemp.token,
    eventType: 'message',
    direction: 'operadora'
  };

  if (infoState.id_type_user === 1 && (infoState.id_profile === 1 || infoState.id_profile === 2)) {
    queryParamsOpAndEnt = {
      'x-access-token': infoStateTemp.token,
      eventType: 'message',
      direction: 'entrevistador'
    };
  }

  /** parâmetros para disparar notificação */
  let queryParams = {
    'x-access-token': infoStateTemp.token,
    eventType: 'message',
    direction: 'corretora',
    id_vend: infosClients.id_user
  };

  if (infoState.id_type_user === 2) {
    queryParams = {
      'x-access-token': infoStateTemp.token,
      eventType: 'message',
      direction: 'operadora'
    };
  }

  /** dispara a notificação */
  const { sendMessage } = useWebSocket(wsURL, {
    queryParams:
      infosClients.statusvenda === 'Realizar entrevista' ||
      infosClients.statusvenda === 'Analisar entrevista' ||
      infosClients.statusvenda === 'Aguardando CPT(s)'
        ? queryParamsOpAndEnt
        : queryParams,
    share: true
  });

  /** parâmetros para ouvir a notificação e atualizar o status da venda */
  let queryParamsConnection = {
    'x-access-token': infoStateTemp.token,
    eventType: 'connection',
    type: 'operadora'
  };

  if (infoState.id_profile === 4) {
    queryParamsConnection = {
      'x-access-token': infoStateTemp.token,
      eventType: 'connection',
      type: 'entrevistador'
    };
  }

  if (infoState.id_type_user === 2) {
    queryParamsConnection = {
      'x-access-token': infoStateTemp.token,
      eventType: 'connection',
      type: 'corretora',
      id_vend: infoState.id
    };
  }

  /** ouve a notificação e chama as funções para atualizar as informações da venda */
  useWebSocket(wsURL, {
    onMessage: (message) => {
      const data = JSON.parse(message.data);
      if (infosClients.id == data.id_client) {
        getInfosClient();
        getCountDocumentsSigning();
        getHistorySales();
      }
    },
    queryParams: queryParamsConnection,
    shouldReconnect: () => true,
    reconnectInterval: 3000
  });

  async function getHistoryEmails() {
    await configAxios
      .get(`/sendEmail/getSendEmailsDocuments/${infosClients.id}`)
      .then((result) => {
        setInfosHistoryEmail(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os emails enviados, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getHistoryWhatsApp() {
    await configAxios
      .get(`/sendEmail/getSendWhstsAppDocuments/${infosClients.id}`)
      .then((result) => {
        setInfosHistoryWhatsApp(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          `Tivemos dificuldades para buscar os Whatsapp's enviados, tente novamente!`,
          'Atenção'
        );
      });
  }

  async function getHistorySales() {
    const id_client = infosClients.id;
    if (infoState.id_type_user === 1 && id_client) {
      configAxios
        .get(`/clients/getHistorySales/${id_client}`)
        .then((result) => {
          setInfosHistorySales(result.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar o histórico de movimentações, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getHistoryHealthMap() {
    const id_client = infosClients.id;
    if (infoState.id_type_user === 1 && id_client) {
      configAxios
        .get(`/clients/getHistoryHealthMap/${id_client}`)
        .then((result) => {
          setInfosHistoryHealthMap(result.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar o histórico de movimentações, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getHistoryIntegration() {
    const id_client = infosClients.id;
    if (infoState.id_type_user === 1 && id_client) {
      configAxios
        .get(`/integration/listHistoryIntegration/${id_client}`)
        .then((result) => {
          const data = result.data;
          setResultIntegration(data.filter((element) => element.status === 'Integrada'));
          setHistoryIntegration(data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar o histórico de integrações, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getHistoryIntegrationThird() {
    const id_client = infosClients.id;
    if (infoState.id_type_user === 1 && id_client) {
      configAxios
        .get(`/integration/listHistoryIntegrationThird/${id_client}`)
        .then((result) => {
          const data = result.data;
          setResultIntegrationThird(data.filter((element) => element.status === 'Integrada'));
          setHistoryIntegrationThird(data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar o histórico de integrações, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function getInfosClient() {
    configAxios
      .get(`/clients/getClientById/${infosClients.id}`)
      .then((response) => {
        let valuesSalesDeps = 0;
        if (Object.keys(infosDeps).length) {
          infosDeps.map((element) => {
            valuesSalesDeps += +element.valclient || 0;
          });
        }

        setInfosClients({
          ...response.data,
          valueTotal: (Number(valuesSalesDeps) + Number(response.data.valclient || 0)).toFixed(2)
        });

        key.current = Math.random();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações do cliente, tente novamente!',
          'Atenção'
        );
      });
  }

  function getCountMessages() {
    const userCount = infoState.id_type_user === 1 ? 'operadora' : 'corretora';
    configAxios
      .get(`/clients/getCountMessages/${infosClients.id}/${userCount}`)
      .then((result) => {
        setCountMessages(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as mensagens, tente novamente!',
          'Atenção'
        );
      });
  }

  function getCountMessagesEntrevis() {
    const userCount =
      infoState.id_profile === 1 || infoState.id_profile === 2 ? 'administrador' : 'entrevistador';
    configAxios
      .get(`/clients/getCountMessagesEntrevis/${infosClients.id}/${userCount}`)
      .then((result) => {
        setCountMessagesEntrevis(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as mensagens, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getCountDocumentsSigning() {
    if (infoState.id_type_user === 1) {
      await configAxios
        .get(`/clients/getCountDocumentsSigning/${infosClients.id}`)
        .then((result) => {
          setCountSigningDocuments(Number(result.data.count));
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar os documentos assinados, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getDependents() {
    await configAxios
      .get(`/clients/infosClientsDependents/${infosClients.id}`)
      .then((response) => {
        setInfosDeps(response.data);
        // console.log(response.data);
        calculateValuesForSales(response.data);

        // Combinar titular + dependentes para o modal de upload
        const titular = {
          id: infosClients.id,
          nome: infosClients.nome,
          cpf: infosClients.cpf_cnpj,
          parentesco: 'Titular',
          tpbenef: 'Titular'
        };

        const allBenefs = [titular, ...response.data];
        setAllBeneficiaries(allBenefs);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os dependentes, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosContract() {
    const router =
      infosClients.id_type_client === 1
        ? `/clients/getInfosSignaturePF/${infosClients.id}`
        : `/clients/getInfosSignaturePJ/${infosClients.id}/null/resp_jur`;

    await configAxios
      .get(router)
      .then((result) => {
        setInfosContract(result.data.health);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function getInfoSelectVend() {
    if (infosClients.id) {
      let idGetVend = infosClients.id_broker ? infosClients.id_broker : infoState.id_broker;
      configAxios
        .get(`/brokers/listVendLabel/${idGetVend}`)
        .then((response) => {
          setInfoSelectVend(response.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar a lista de vendedores! Tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function getInfosOrgaoEmissor() {
    configAxios
      .get('utilsInfos/getInfosOrgaoEmissor')
      .then((response) => {
        setInfosOrgaEmissor(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações do RG! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getPlans(tpcontrat = undefined, idregiao = false) {
    let id_broker = infosClients.id_broker ? infosClients.id_broker : infoState.id_broker;
    let codcontratotpcontrat;

    if (tpcontrat) {
      codcontratotpcontrat = '01';
      if (tpcontrat === '2-COLETIVO EMPRESARIAL') {
        codcontratotpcontrat = '02';
      }
    }

    if (infoState.controlaregiao === 'Sim' && idregiao === false) {
      return;
    }

    await configAxios
      .get(`products/getPlansLabel/${id_broker}/${codcontratotpcontrat}/${idregiao}`)
      .then((response) => {
        setInfosPlans(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações do Plano! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getDaysTerms(tpcontrat, idregiao) {
    configAxios
      .get(`/terms/daysOfTerm?tpcontrat=${tpcontrat}&id_regiao=${idregiao}`)
      .then((response) => {
        if (response.data.length > 0) {
          if (response.data[0].status === 'ATIVO') {
            setInfosDaysTerms(response.data);
          }
        } else {
          setInfosDaysTerms([]);
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as vigências no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  async function getTypesOfHiring() {
    configAxios
      .get(`/config/getTypesOfHiring`)
      .then((response) => {
        setInfosTypesOfHiring(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar os tipos de contratação no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  async function getTables() {
    let id_broker = infosClients.id_broker ? infosClients.id_broker : infoState.id_broker;

    await configAxios
      .get(`/tables/getTablesLabel/${id_broker}`)
      .then((response) => {
        setInfosTables(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações das tabelas! Tente novamente!',
          'Atenção'
        );
      });
  }

  function getPlansAssociation(id_association, id_broker, idregiao = false) {
    const idBroker = id_broker ? id_broker : infoState.id_broker;
    if (infoState.controlaregiao === 'Sim' && (idregiao === false || idregiao === null)) {
      NotificationManager.warning(
        'Necessário selecionar a região para buscar os produtos!',
        'Atenção'
      );
      return;
    }
    if (id_association) {
      configAxios
        .get(`products/getPlansAssociationLabel/${id_association}/${idBroker}/${idregiao}`)
        .then((response) => {
          setInfosPlans(response.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar as informações do Plano! Tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getTablesAssociation(id_association) {
    if (id_association) {
      await configAxios
        .get(`/tables/getTablesAssociationLabel/${id_association}`)
        .then((response) => {
          setInfosTables(response.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar as informações das tabelas! Tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function getWaitingPeriod() {
    await configAxios
      .get(`/waitiginPeriod/getWaitingPeriod`)
      .then((response) => {
        setInfosWaitingPeriod(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações das carências! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getAssociations() {
    let id_broker = infosClients.id_broker ? infosClients.id_broker : infoState.id_broker;
    await configAxios
      .get(`/association/listAssociationLabel/${id_broker}`)
      .then((response) => {
        setInfosAssociation(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações das associações! Tente novamente!',
          'Atenção'
        );
      });
  }

  function getFilesUploads() {
    if (infosClients.id) {
      configAxios
        .get(`/uploads/listUploads/${infosClients.id}`)
        .then((response) => {
          setInfosUploads(response.data);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar os uploads, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function getAddress() {
    configAxios
      .get(`/address/listAddress/null/${infosClients.id}`)
      .then((response) => {
        setInfosAddress(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os endereços no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function AddAddressModal(id) {
    if (id) {
      const valuesEdit = infosAddress.filter((element) => element.id === id);
      setInfosAddressEdit(valuesEdit);
    }
    setOpenModalAddress(true);
  }

  function calculateValuesForSales(infosDepsValues) {
    let valuesSalesDeps = 0;
    if (Object.keys(infosDepsValues).length) {
      infosDepsValues.map((element) => {
        valuesSalesDeps += +element.valclient || 0;
      });
    }
    setInfosClients((prev) => ({
      ...prev,
      valueTotal: (Number(valuesSalesDeps) + Number(prev.valclient || 0)).toFixed(2)
    }));
  }

  function HandleGetSimulation(event) {
    if (event.target.value) {
      configAxios
        .get(
          `/simulations/getSimulationByCodSimulation/${event.target.value}/${infoState.id_broker}/${infoState.id}`
        )
        .then((result) => {
          if (!result.data.length) {
            NotificationManager.warning(
              'Simulação não encontrada ou já está em uso, tente novamente!',
              'Atenção'
            );
            infosClients.codsimulation = '';
            return;
          }
          delete result.data[0].id;
          let titBenef = 'N';

          if (result.data[0].id_type_client === 1) {
            titBenef = 'S';
          }

          setInfosClients({
            ...infosClients,
            valueTotal: 0,
            titbenef: titBenef,
            ...result.data[0]
          });
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar a simulação, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function buscarDadosDirectData(cpf) {
    if (!cpf || cpfBuscado === cpf) return;

    try {
      const response = await configAxios.get('/directdata/cpf', {
        params: { cpf }
      });

      if (response.status === 202) {
        NotificationManager.warning(response.data, 'Atenção');
        return;
      }

      if (response.data && response.data.retorno) {
        const dados = response.data.retorno;

        let dataNascimento = '';
        if (dados.dataNascimento) {
          const partes = dados.dataNascimento.split('/');
          // console.log(partes);
          if (partes.length === 3) {
            dataNascimento = `${partes[2].split(' ')[0]}-${partes[1]}-${partes[0]}`;
          }
        }

        const dadosPreenchidos = {
          ...infosClients,
          cpf_cnpj: cpf,
          nome: dados.nome || infosClients.nome,
          dtnascimento: dataNascimento || infosClients.dtnascimento,
          nomedamae: dados.nomeMae || infosClients.nomemae,
          sexo: dados.sexo || infosClients.sexo
        };

        if (dados.emails && dados.emails.length > 0) {
          dadosPreenchidos.email = dados.emails[0].enderecoEmail || infosClients.email;
        }

        setInfosClients(dadosPreenchidos);
        setCpfBuscado(cpf);

        validDtnascimento(dadosPreenchidos.dtnascimento);
        // NotificationManager.success('Dados preenchidos automaticamente pelo DirectData', 'Sucesso');
      }
    } catch (error) {
      NotificationManager.warning(
        'Tivemos dificuldades para buscar a as informações, tente novamente!',
        'Atenção'
      );
    }
  }

  async function consultaBlacklist(cpf) {
    try {
      const response = await configAxios.get('/blacklist/cpf', {
        params: { cpf }
      });

      return response;
    } catch (error) {
      NotificationManager.warning(
        'Tivemos dificuldades para consultar a blacklist, tente novamente!',
        'Atenção'
      );
      return { status: 500 };
    }
  }

  async function validCPF(event) {
    const cpfValue = event.target.value;

    if (cpfValue) {
      const cpfIsValid = validateCPF(cpfValue);

      if (infosClients.id_type_client === 1) {
        if (!cpfIsValid) {
          NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
          setInfosClients({ ...infosClients, cpf_cnpj: '' });
          return;
        }
        // Consulta blacklist
        if (cpfBuscado !== cpfValue && infoState.consultablacklist === 'Sim') {
          const res = await consultaBlacklist(cpfValue);
          if (res.status === 202) {
            NotificationManager.warning(
              'Não é possível continuar o cadastro com esse CPF, favor verificar com a operadora/administradora!',
              'Atenção'
            );
            setInfosClients({ ...infosClients, cpf_cnpj: '' });
            return;
          }
          if (res.status === 500) {
            setInfosClients({ ...infosClients, cpf_cnpj: '' });
            return;
          }
        }
        // Só busca se não foi buscado antes
        if (cpfBuscado !== cpfValue && infoState.integradirectdata === 'Sim') {
          await buscarDadosDirectData(cpfValue);
        }
      } else {
        if (!cpfIsValid) {
          NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
          setInfosClients({ ...infosClients, cpf_cnpj_resp: '' });
          return;
        }
      }
    }
  }

  async function buscarDadosDirectDataCNPJ(cnpj) {
    if (!cnpj || cpfBuscado === cnpj) return false;

    try {
      const response = await configAxios.get('/directdata/cnpj', {
        params: { cnpj }
      });

      if (response.status === 202) {
        NotificationManager.warning(response.data, 'Atenção');
        return false;
      }

      if (response.data && response.data.retorno) {
        const dados = response.data.retorno;

        const dadosPreenchidos = {
          ...infosClients,
          cpf_cnpj: cnpj,
          nome: dados.razaoSocial || infosClients.nome,
          nomefantasia: dados.nomeFantasia || infosClients.nomefantasia
        };

        if (dados.emails && dados.emails.length > 0) {
          dadosPreenchidos.email = dados.emails[0].enderecoEmail || infosClients.email;
        }
        setInfosClients(dadosPreenchidos);
        setCpfBuscado(cnpj);
        // NotificationManager.success('Dados preenchidos automaticamente pelo DirectData', 'Sucesso');
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  async function validCNPJ(event) {
    const cnpjValue = event.target.value;

    if (cnpjValue) {
      const cnpjIsValid = validateCNPJ(cnpjValue);
      if (!cnpjIsValid) {
        NotificationManager.warning('CNPJ inválido, por favor verifique!', 'Atenção');
        setInfosClients({ ...infosClients, cpf_cnpj: '' });
        return;
      }

      // Só busca se não foi buscado antes
      let buscouDirectData = false;
      if (cpfBuscado !== cnpjValue && infoState.integradirectdata === 'Sim') {
        buscouDirectData = await buscarDadosDirectDataCNPJ(cnpjValue);
      }

      if (!buscouDirectData) {
        let infosCNPJ = false;
        if (!infosClients.nome && !infosClients.nomefantasia) {
          infosCNPJ = await viaCNPJ(cnpjValue);
        }
        if (infosCNPJ) {
          setInfosClients({
            ...infosClients,
            ['nome']: infosCNPJ.nome,
            ['nomefantasia']: infosCNPJ.nomefantasia,
            [event.target.name]: cnpjValue
          });
          return;
        }
        setInfosClients({ ...infosClients, [event.target.name]: cnpjValue });
      }
    }
  }

  function showDeclarationHealthModal() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para visualizar a declaração de saúde!',
        'Atenção'
      );
      return;
    }

    if (rowSelected.completedhealthdeclaration === false) {
      NotificationManager.warning(
        'Declaração ainda não preenchida, selecione o botão preencher para preencher a declaração!',
        'Atenção'
      );
      return;
    }
    getResponsesQuestions();
    setShowDeclaration(true);
    setOpenModalDeclarationHealth(true);
  }

  function selectedRow(event) {
    const selected = event.selectedRowsData[0];
    setRowSelected(selected);
  }

  async function getResponsesQuestions() {
    const flag = rowSelected.flag ? 'tb_clients' : 'tb_clients_dep';
    const id = flag === 'tb_clients' ? infosClients.id : rowSelected.id;

    const router =
      infosClients.id_type_client === 1
        ? `/questions/getResponsesQuestionsPF/${id}/${flag}`
        : `/questions/getResponsesQuestionsPJ/${rowSelected.id}`;

    await configAxios
      .get(router)
      .then((response) => {
        setResponseQuestions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosQuestions() {
    await configAxios
      .get('/questions/listQuestions')
      .then((response) => {
        setInfosQuestions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function extrairAlturaEPeso(responses) {
    let altura = null;
    let peso = null;

    responses.forEach((item) => {
      if (!item.pergunta || !item.resposta) return;

      const valor = parseFloat(item.resposta.toString().trim().replace(',', '.'));
      const perguntaLower = item.pergunta.toLowerCase();
      const isAltura =
        perguntaLower.includes('altura') ||
        infosQuestions.find((q) => q.id === item.id_question && q.tpresposta === 'Altura');
      const isPeso =
        perguntaLower.includes('peso') ||
        infosQuestions.find((q) => q.id === item.id_question && q.tpresposta === 'Peso');

      if (isAltura && !isNaN(valor) && valor > 0) altura = valor;
      if (isPeso && !isNaN(valor) && valor > 0) peso = valor;
    });

    return { altura, peso };
  }

  function getCorIMC(imc) {
    if (!imc || isNaN(imc)) return null;
    if (imc < 18.5) return '#81D4FA'; // Azul claro
    if (imc >= 18.5 && imc < 25) return '#66BB6A'; // Verde
    if (imc >= 25 && imc < 30) return '#FFD54F'; // Amarelo
    if (imc >= 30 && imc < 35) return '#FFA726'; // Laranja
    return '#EF5350'; // Vermelho (>=35)
  }

  function calcularIdade(dataNascimento) {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
    return idade;
  }

  function checkParametrosDeclinio(beneficiaries) {
    // setParametrosAlerta({ show: false, message: '' });

    const tipoContrato = infosClients.tpcontrat_client;
    const statusVenda = infosClients.statusvenda;
    let geraAlerta = false;
    // Verificar idade (apenas para Coletivo por Adesão e Individual Familiar)
    const limiteIdade = parseFloat(infoState.idade_declinio);
    if (
      limiteIdade &&
      tipoContrato &&
      tipoContrato !== '2-COLETIVO EMPRESARIAL' &&
      (tipoContrato === '3-COLETIVO POR ADESAO' || tipoContrato === '1-INDIVIDUAL FAMILIAR')
    ) {
      // Verificar titular
      if (infosClients.titbenef === 'S' && infosClients.dtnascimento) {
        const idade = calcularIdade(infosClients.dtnascimento);
        if (idade && idade > limiteIdade) {
          geraAlerta = true;
        }
      }

      // Verificar dependentes
      if (!geraAlerta) {
        geraAlerta = beneficiaries?.some((b) => {
          const dataNasc = b.dtnascimento || b.datanascimento;
          const idade = dataNasc ? calcularIdade(dataNasc) : null;
          return idade && idade > limiteIdade;
        });
      }
    }

    // Verificar mínimo de vidas (apenas para Empresarial e status diferente de Aberta)
    if (!geraAlerta && tipoContrato === '2-COLETIVO EMPRESARIAL' && statusVenda !== 'Aberta') {
      const minimoVidas = parseInt(infoState.minimo_vidas_empresarial);
      if (minimoVidas) {
        const totalBeneficiarios = beneficiaries?.length || 0;
        if (totalBeneficiarios < minimoVidas) {
          geraAlerta = true;
        }
      }
    }

    // Verificar razão de dependência (apenas para Empresarial e status diferente de Aberta)
    if (!geraAlerta && tipoContrato === '2-COLETIVO EMPRESARIAL' && statusVenda !== 'Aberta') {
      const razaoMaxima = parseFloat(infoState.razao_dependencia_maxima);
      if (razaoMaxima) {
        const titulares = beneficiaries?.filter((b) => b.flag === true).length || 0;
        const dependentes = beneficiaries?.filter((b) => b.flag === false).length || 0;
        const razaoDependencia = titulares > 0 ? (dependentes / titulares) * 100 : 0;
        if (razaoDependencia > razaoMaxima) {
          geraAlerta = true;
        }
      }
    }
    // Exibir geraAlerta se houver algum problema
    if (geraAlerta) {
      setParametrosAlerta({
        show: true,
        message:
          infoState.mensagem_declinio ||
          'Atenção: A venda contém informações que precisam ser validadas conforme os parâmetros de declínio.'
      });
    }
  }

  async function checkIMCAllBeneficiaries(beneficiaries) {
    const limiteIMC = parseFloat(infoState.imc_declinio);
    if (!limiteIMC || !beneficiaries?.length) {
      setImcAlerta({ show: false, message: '' });
      setImcCalculado({});
      return;
    }

    const beneficiariosComDeclaracao = beneficiaries.filter(
      (benef) => benef.completedhealthdeclaration
    );

    if (!beneficiariosComDeclaracao.length) {
      setImcAlerta({ show: false, message: '' });
      setImcCalculado({});
      return;
    }

    const imcMap = {};
    const promises = beneficiariosComDeclaracao.map((beneficiary) => {
      const flag = beneficiary.flag ? 'tb_clients' : 'tb_clients_dep';
      const id = flag === 'tb_clients' ? infosClients.id : beneficiary.id;
      const beneficiaryKey = flag === 'tb_clients' ? `titular_${id}` : `dependente_${id}`;

      return configAxios
        .get(`/questions/getResponsesQuestionsPF/${id}/${flag}`)
        .then((response) => {
          const { altura, peso } = extrairAlturaEPeso(response.data || []);
          if (altura && peso) {
            const imc = peso / (altura * altura);
            imcMap[beneficiaryKey] = parseFloat(imc.toFixed(2));
            return imc > limiteIMC;
          }
          return false;
        })
        .catch(() => false);
    });

    const results = await Promise.all(promises);
    const hasIMCAboveLimit = results.some((result) => result === true);
    setImcCalculado(imcMap);
    const mensagemDeclinio = infoState.mensagem_declinio || '';

    setImcAlerta(
      hasIMCAboveLimit
        ? {
            show: true,
            message: mensagemDeclinio
          }
        : { show: false, message: '' }
    );
    setParametrosAlerta(
      hasIMCAboveLimit
        ? {
            show: true,
            message: mensagemDeclinio
          }
        : { show: false, message: '' }
    );
  }

  function HandleInputChange(event, params = {}) {
    if (params.autocomplete) {
      if (event) {
        setInfosClients({ ...infosClients, label: event.label, id_orgao: event.id });
        return;
      }
      return;
    }
    if (params.regiao) {
      if (event) {
        clearPlansAndTables();
        setSalesValue('');
        setInfosPlans();
        getDaysTerms(infosClients.tpcontrat_client, event.idregiao);
        setInfosClients({
          ...infosClients,
          labelregiao: event.label,
          id_regiao: event.idregiao,
          dtvigencia: null
        });
        if (infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO') {
          if (infosClients.id_type_client !== 1) {
            NotificationManager.warning(
              'Só é possível vincular o tipo de contratação coletivo por adesão a clientes pessoa física!',
              'Atenção'
            );
            return;
          }
          infosClients.titbenef = 'S';
          clearPlansAndTables();
          getPlansAssociation(infosClients.id_association, infosClients.id_broker, event.idregiao);
          getTablesAssociation(infosClients.id_association);
          getAssociations();
          // getDaysTerms(infosClients.tpcontrat, event.idregiao);
          return;
        } else {
          clearPlansAndTables();
          getPlans(infosClients.tpcontrat_client, event.idregiao);
          // getDaysTerms(infosClients.tpcontrat, event.idregiao);
          getTables();
          return;
        }
      }
      // setSalesValue('');
      // clearPlansAndTables();
      // setInfosPlans();
      return;
    }
    if (params.plan) {
      if (event) {
        const infosTablesTemp = infosTables.filter(
          (element) => element.codplano === event.codplano
        );

        setInfosTablesTemp([]);
        infosTablesTemp.unshift({ id: '', label: '' });
        setInfosTablesTemp(infosTablesTemp);
        infosClients.labeltables = '';
        setSalesValue('');
        infosClients.codtab = '';

        setInfosClients({
          ...infosClients,
          labelplans: event.label,
          codplano: event.codplano
        });

        if (infosClients.id && infoState.mutiplosplanos === 'Não') {
          NotificationManager.warning(
            'Ao alterar o plano e salvar, os planos dos titulares e dependentes serão recalculados com base no novo plano/tabela!',
            'Atenção'
          );
        }
        return;
      }
      return;
    }
    if (params.table) {
      if (event) {
        setInfosClients({ ...infosClients, labeltables: event.label, codtab: event.codtab });
        setSalesValue('');
        if (infosClients.id && infoState.mutiplosplanos === 'Não') {
          NotificationManager.warning(
            'Ao alterar a tabela e salvar, os planos dos titulares e dependentes serão recalculados com base no novo plano/tabela!',
            'Atenção'
          );
        }
        return;
      }
      return;
    }
    if (params.cep) {
      setInfosClients({ ...infosClients, ...params.cep });
      return;
    }
    if (params.vend) {
      setInfosClients({ ...infosClients, labelvend: event.label, id_user: event.id });
      return;
    }
    if (params.waitingPeriod) {
      if (event) {
        setInfosClients({
          ...infosClients,
          labelcarencia: event.label,
          codcarencia: event.codcarencia
        });
        return;
      }
      return;
    }

    if (params.association) {
      if (event) {
        clearPlansAndTables();
        setInfosClients({
          ...infosClients,
          labelassociation: event.label,
          id_association: event.id_association
        });
        getPlansAssociation(event.id_association, infosClients.id_broker, infosClients.id_regiao);
        getTablesAssociation(event.id_association);
        return;
      }
      return;
    }
    if (event) {
      if (event.target.name === 'tpcontrat_client') {
        getDaysTerms(event.target.value, event.idregiao);
      }
    }
    if (event.target.name === 'dtnascimento') {
      setSalesValue('');

      if (event.target.value > new Date()) {
        NotificationManager.warning('Data de nascimento inválida, verifique!', 'Atenção');
        return;
      }
      if (calcularIdade(event.target.value) < 18) {
        NotificationManager.warning(
          'Não é possível realizar a venda para beneficiários menores de idade!',
          'Atenção'
        );
        infosClients.dtnascimento = '';
        setInfosClients({ ...infosClients, dtnascimento: null });
        return;
      }
      if (infosClients.tpcontrat === '3-COLETIVO ADESAO') {
        if (infosClients.idademinina !== null && infosClients.idademinina !== '') {
          const idade = calcularIdade(event.target.value);
          // console.log(idade);
          if (infosClients.idademinina > idade) {
            NotificationManager.warning(
              'Não é possível realizar a venda para essa idade utilizando essa associação, verifique!',
              'Atenção'
            );
            infosClients.dtnascimento = '';
            setInfosClients({ ...infosClients, dtnascimento: null });
          }
        }
      }
    }

    if (event.target.name === 'titbenef') {
      delete infosClients.valclient;
      setSalesValue('');
    }

    if (event.target.name === 'tpcontrat_client') {
      clearPlansAndTables();
      infosClients.titbenef = 'N';

      infosClients.labelregiao = '';
      infosClients.id_regiao = null;

      if (event.target.value === '3-COLETIVO POR ADESAO') {
        if (infosClients.id_type_client !== 1) {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação coletivo por adesão a clientes pessoa física!',
            'Atenção'
          );
          return;
        }
        infosClients.titbenef = 'S';

        getPlansAssociation(infosClients.id_association, infosClients.id_broker);
        getTablesAssociation(infosClients.id_association);

        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
      } else {
        if (infosClients.id_type_client !== 1 && event.target.value === '1-INDIVIDUAL/FAMILIAR') {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação invidual/familiar a clientes pessoa física!',
            'Atenção'
          );
          return;
        }
        if (infosClients.id_type_client === 1 && event.target.value === '2-COLETIVO EMPRESARIAL') {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação coletivo empresarial a clientes pessoa jurídica!',
            'Atenção'
          );
          return;
        }

        if (event.target.name === 'email' || event.target.name === 'email_contato') {
          event.target.value = event.target.value.toLowerCase();
        }
        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
        getTables();
        getPlans(event.target.value);
      }
      return;
    }

    if (event.target.name === 'id_type_client') {
      infosClients.tpcontrat_client = '';
    }

    // console.log(event.target.name);
    // console.log(event.target.value);
    // console.log(infoState.analisemedica);

    if (event.target.name === 'statusvenda') {
      if (event.target.value === 'Aguardando cliente') {
        if (
          infoState.tipointegracao !== 'Não possui' &&
          infosClients.statusvenda === infoState.statusintegracao &&
          !resultIntegration.length
        ) {
          NotificationManager.warning('É necessário integrar a venda para prosseguir', 'Atenção');
          return;
        } else if (
          infoState.tipointegracao !== 'Não possui' &&
          infoState.controlacontrato === 'Sim' &&
          !infosClients.codcontrato &&
          infosClients.statusvenda === infoState.statusintegracao
        ) {
          NotificationManager.warning('Por favor, preencha o código do contrato!', 'Atenção');
          return;
        } else {
          HandleInputStatusSalesChange(event);
        }
      }
      if (event.target.value === 'Realizar entrevista') {
        HandleInputStatusSalesChange(event);
      }
      if (event.target.value === 'Analisar entrevista') {
        HandleInputStatusSalesChange(event);
      }
      if (event.target.value === 'Aguardando CPT(s)') {
        const hasClaimed = infosClientsHealth.some((item) => item.claim === true);
        if (!hasClaimed) {
          NotificationManager.warning(
            'Não há beneficiários com agravo para prosseguir com o status aguardando CPT(s)',
            'Atenção'
          );
          return;
        }
        HandleInputStatusSalesChange(event);
      }
      if (event.target.value === 'Aguardando operadora' && infoState.analisemedica === 'Sim') {
        HandleInputStatusSalesChange(event);
      }
    }

    if (event.target.name === 'statusvenda' && infoState.id_type_user === 1) {
      if (!infosClients.senha) {
        NotificationManager.warning('Por favor, gere a senha!', 'Atenção');
        return;
      }
    }

    if (event.target.name === 'email' || event.target.name === 'email_contato') {
      event.target.value = event.target.value.toLowerCase();
    }

    setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
  }

  function clearPlansAndTables() {
    setInfosTablesTemp([]);
    setInfosTables([]);
    setSalesValue('');
    setInfosPlans([]);

    infosClients.codtab = '';
    infosClients.labeltables = '';
    infosClients.labelplans = '';
    infosClients.codplano = '';
  }

  async function PendingHealthDeclarationAndSigning() {
    const routerPending =
      infosClients.id_type_client === 1
        ? `/clients/pendingDeclarationHealth/${infosClients.id}/true`
        : `/clients/pendingDeclarationHealth/${infosClients.id}/false`;

    if (
      infoState.tipooperacao !== 'Cartão' &&
      infoState.tipooperacao !== 'Odonto' &&
      infosClients.included_shortage === 'S'
    ) {
      await configAxios.get(routerPending).then((result) => {
        if (result.data.length > 0) {
          setPendingInfosDeclarationHealth(result.data);
          setHeaderModalPending('Declarações de saúde pendentes');
          setOpenModalPendingHealth(true);
        } else {
          configAxios
            .get(
              `/clients/pendingSigningDocuments/${infosClients.id}/null/${infosClients.id_type_client}/true/S`
            )
            .then((result) => {
              setPendingInfosDeclarationHealth(result.data);
              setHeaderModalPending('Assinaturas de documentos pendentes');
              setOpenModalPendingHealth(true);
            })
            .catch(() => {
              NotificationManager.warning(
                'Tivemos dificuldades para buscar as pendências, por favor, tente novamente!',
                'Atenção'
              );
            });
        }
      });
    } else {
      configAxios
        .get(
          `/clients/pendingSigningDocuments/${infosClients.id}/null/${infosClients.id_type_client}/true/N`
        )
        .then((result) => {
          setPendingInfosDeclarationHealth(result.data);
          setHeaderModalPending('Assinaturas de documentos pendentes');
          setOpenModalPendingHealth(true);
        })
        .catch(() => {
          NotificationManager.warning(
            'Tivemos dificuldades para buscar as pendências, por favor, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function HandleInputStatusSalesChange(event) {
    if (infoState.id_type_user === 1) {
      if (!infosClients.senha) {
        return;
      }
    }
    if (infoState.id_type_user === 2 && !infosAddress.length) {
      NotificationManager.warning(
        'Por favor, cadastre um endereço para prosseguir com a mudança de status!',
        'Atenção'
      );
      return;
    }
    if (infoState.id_type_user === 2 && !infosDeps.length && infosClients.id_type_client === 2) {
      NotificationManager.warning(
        'Por favor, cadastre ao menos um beneficiário para prosseguir com a mudança de status!',
        'Atenção'
      );
      return;
    }
    if (infoState.id_type_user === 2 && !infosDeps.length && infosClients.id_type_client === 2) {
      NotificationManager.warning(
        'Por favor, cadastre ao menos um beneficiário para prosseguir com a mudança de status!',
        'Atenção'
      );
      return;
    }
    if (infoState.id_type_user === 2) {
      const toSlug = (str) =>
        str
          ? String(str)
              .trim()
              .normalize('NFD') // Remove acentos
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/[^a-z0-9_]/g, '')
          : '';

      const normalizeDigits = (str) => (str ? String(str).replace(/[^a-z0-9]/g, '') : '');

      const hasDocs = Array.isArray(infosDocs) && infosDocs.length > 0;

      if (hasDocs) {
        const clientCpf = normalizeDigits(infosClients?.cpf_cnpj);
        const clientId = String(infosClients?.id || infosClients?.id_client || '');

        // Identifica o Tipo de Contratação (1: Individual, 2: Empresarial, 3: Adesão)
        const tpContrat = Number(infosClients?.tpcontrat_client || infosClients?.id_tpcontrat);
        const isEmpresarial = tpContrat === 2;

        const invalidDocs = [];

        const listToValidate =
          Array.isArray(allBeneficiaries) && allBeneficiaries.length > 0
            ? allBeneficiaries
            : selectedBeneficiaries;

        listToValidate.forEach((person) => {
          const personCpf = normalizeDigits(person.cpf || person.cpf_cnpj);
          const isSameCpfOrId =
            (personCpf !== '' && personCpf === clientCpf) || String(person.id) === clientId;

          // 1. Identifica se é EMPRESA (PJ)
          const isSelectedEmpresa =
            isEmpresarial &&
            (isSameCpfOrId || person.titbenef === 'E' || person.tipo === 'empresa');

          // 2. Identifica se é RESPONSÁVEL JURÍDICO
          const isSelectedRespJuridico =
            !isSelectedEmpresa &&
            infosClients?.id_type_client === 1 &&
            (infosClients?.titbenef === 'N' ||
              person.titbenef === 'R' ||
              person.tipo === 'responsavel') &&
            isSameCpfOrId;

          // 3. É BENEFICIÁRIO COMUM se não for Empresa nem Responsável Jurídico
          const isBeneficiarioComum = !isSelectedEmpresa && !isSelectedRespJuridico;

          // Definição do Nome para exibição no Modal de Pendências
          let personName = person.nome;
          if (!personName) {
            if (isSelectedEmpresa) personName = 'Empresa';
            else if (isSelectedRespJuridico) personName = 'Responsável Jurídico';
            else personName = 'Beneficiário';
          }

          // --- FILTRO DE DOCUMENTOS RELEVANTES PARA A PESSOA ---
          const relevantDocs = infosDocs.filter((doc) => {
            // Validação por Tipo de Contratação (tpcontrat) se houver no doc
            const clientTpContratSlug = toSlug(
              infosClients?.tpcontrat ||
                infosClients?.id_tpcontrat ||
                infosClients?.tipo_contratacao
            );
            const docTpContratSlug = toSlug(doc.tpcontrat);

            if (docTpContratSlug && clientTpContratSlug) {
              if (docTpContratSlug !== clientTpContratSlug) {
                return false;
              }
            }

            // Filtro de Formato (HigiaSaude)
            if (company === 'higiasaude' && doc.formato && infosClients?.formato) {
              if (toSlug(doc.formato) !== toSlug(infosClients.formato)) {
                return false;
              }
            }

            const docDirecao = toSlug(doc.direcao);

            // Direção: Empresa
            if (docDirecao === 'empresa') {
              return isSelectedEmpresa;
            }

            // Direção: Responsável Jurídico ("responsavel", "responsavel_juridico", "responsaveljuridico")
            if (docDirecao.includes('responsavel')) {
              return isSelectedRespJuridico;
            }

            // Direção: Beneficiário
            if (docDirecao === 'beneficiario') {
              return isBeneficiarioComum;
            }

            // Se for uma direção geral ou não informada, aplica a todos
            return true;
          });

          // --- SELEÇÃO DE DOCUMENTOS OBRIGATÓRIOS ---
          const requiredDocs = relevantDocs.filter((doc) => doc.obrigatorio);

          // --- VALIDAÇÃO DE QUANTIDADE ENVIADA ---
          requiredDocs.forEach((reqDoc) => {
            const requiredTypeSlug = toSlug(reqDoc.nome);
            const requiredQtde = reqDoc.qtde || 1;

            const uploadedCount = (infosUploads || []).filter((upload) => {
              const uploadTypeSlug = toSlug(upload.tpdocument);
              const uploadIdDep = String(upload.id_dep);

              // Associa os envios do id_client ou id da pessoa selecionada
              const isSamePerson =
                isSelectedEmpresa || isSelectedRespJuridico
                  ? uploadIdDep === clientId || uploadIdDep === String(person.id)
                  : uploadIdDep === String(person.id);

              return uploadTypeSlug === requiredTypeSlug && isSamePerson;
            }).length;

            if (uploadedCount < requiredQtde) {
              invalidDocs.push({
                pessoa: personName,
                docNome: reqDoc.nome,
                enviados: uploadedCount,
                esperados: requiredQtde
              });
            }
          });
        });

        // --- EXIBE MODAL COM PENDÊNCIAS SE HOUVER ---
        if (invalidDocs.length > 0) {
          setPendingDocsList(invalidDocs);
          setOpenModalPending(true);
          return;
        }

        // --- VALIDAÇÃO COMPLEMENTAR DE SEGURANÇA ---
        const totalRequiredCount = listToValidate.reduce((acc, person) => {
          const personCpf = normalizeDigits(person.cpf || person.cpf_cnpj);
          const isSameCpfOrId =
            (personCpf !== '' && personCpf === clientCpf) || String(person.id) === clientId;

          const isSelectedEmpresa =
            isEmpresarial &&
            (isSameCpfOrId || person.titbenef === 'E' || person.tipo === 'empresa');

          const isSelectedRespJuridico =
            !isSelectedEmpresa &&
            infosClients?.id_type_client === 1 &&
            (infosClients?.titbenef === 'N' ||
              person.titbenef === 'R' ||
              person.tipo === 'responsavel') &&
            isSameCpfOrId;

          const isBeneficiarioComum = !isSelectedEmpresa && !isSelectedRespJuridico;

          return (
            acc +
            infosDocs.filter((d) => {
              if (!d.obrigatorio) return false;
              const docDirecao = toSlug(d.direcao);

              if (docDirecao === 'empresa') return isSelectedEmpresa;
              if (docDirecao.includes('responsavel')) return isSelectedRespJuridico;
              if (docDirecao === 'beneficiario') return isBeneficiarioComum;

              return true;
            }).length
          );
        }, 0);

        if (totalRequiredCount === 0 && (!infosUploads || infosUploads.length === 0)) {
          NotificationManager.warning(
            'Por favor, envie ao menos um documento para prosseguir com a mudança de status!',
            'Atenção'
          );
          return;
        }
      } else {
        // Fallback: Se infosDocs estiver vazio
        if (!infosUploads || infosUploads.length === 0) {
          NotificationManager.warning(
            'Por favor, envie ao menos um documento para prosseguir com a mudança de status!',
            'Atenção'
          );
          return;
        }
      }
    }
    setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
    const infosUpdate = {
      id: infosClients.id,
      statusvenda: event.target.value,
      user_id: infoState.id,
      id_type_user: infoState.id_type_user,
      id_vend: infosClients.id_user,
      senha: infoState.id_type_user === 1 ? infosClients.senha : null,
      codclient: infosClients.codclient,
      codcontrato: infosClients.codcontrato ? infosClients.codcontrato : null,
      dtvigencia: infosClients.dtvigencia
    };

    configAxios
      .post('/clients/updateStatusSales', infosUpdate)
      .then(() => {
        NotificationManager.success('Status atualizado com sucesso!', 'Sucesso');
        sendMessage();
        if (
          infoState.tipo === 'Complexo' &&
          infosUpdate.statusvenda === 'Aguardando cliente' &&
          infoState.id_type_user === 1
        ) {
          setOpenModalSendEmailDocuments(true);
          setOpenModalSendWhatsAppDocuments(true);
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atualizar o status, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleChangeCodContract(event) {
    if (event && initialInfosClients.codcontrato !== event.target.value) {
      const infosUpdate = {
        id: infosClients.id,
        codcontrato: event.target.value,
        user_id: infoState.id
      };
      configAxios
        .post('/clients/updateCodContract', infosUpdate)
        .then(() => {
          NotificationManager.success('Código do contrato atualizado com sucesso!', 'Sucesso');
          setInfosClients({ ...infosClients, codcontrato: event.target.value });
          initialInfosClients.codcontrato = event.target.value;
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para atualizar o código do contrato, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function validDtnascimento(dataNascimento = null) {
    infosClients.dtnascimento = dataNascimento ? dataNascimento : infosClients.dtnascimento;

    if (
      infosClients.dtnascimento > new Date().toLocaleDateString().split('/').reverse().join('-')
    ) {
      NotificationManager.warning('Por favor, escolha uma data de nascimento válida!', 'Atenção');
      infosClients.dtnascimento = '';
      setInfosClients({ ...infosClients, dtnascimento: null });
      return;
    }

    // console.log(infosClients.tpcontrat);
    // console.log(infosClients.idademinima);

    if (infosClients.tpcontrat == '3-COLETIVO POR ADESAO') {
      const idade = calcularIdade(infosClients.dtnascimento);
      // console.log(idade);
      if (infosClients.idademinima) {
        const idade = calcularIdade(infosClients.dtnascimento);
        if (infosClients.idademinima > idade) {
          NotificationManager.warning(
            'Não é possível realizar a venda para essa idade utilizando essa associação, verifique!',
            'Atenção'
          );
          setInfosClients({ ...infosClients, dtnascimento: null });
          infosClients.dtnascimento = '';
        }
      }
    }
    return;
  }

  function validDtvigencia() {
    if (new Date().toLocaleDateString().split('/').reverse().join('-') > infosClients.dtvigencia) {
      NotificationManager.warning(
        'Datas de vigências anteriores a data de hoje não são aceitas!',
        'Atenção'
      );
      infosClients.dtvigencia = '';
      setInfosClients({ ...infosClients, dtvigencia: null });
      return;
    }
    if (infosDaysTerms.length > 0 && infosClients.dtvigencia) {
      const [anoSel, mesSel, diaSel] = infosClients.dtvigencia.split('-');
      const today = new Date();
      const currentDay = today.getDate();
      const currentMonth = today.getMonth() + 1;
      const currentYear = today.getFullYear();
      const dayOfVigence = infosDaysTerms.find((day) => day.dia === diaSel);
      let block = false;

      if (!dayOfVigence) {
        block = true;
      } else {
        // Se o dia existe, verificamos a data de corte apenas para o mês/ano atual
        const isCurrentMonth = Number(mesSel) === currentMonth && Number(anoSel) === currentYear;
        if (isCurrentMonth && currentDay > Number(dayOfVigence.dia_corte)) {
          block = true;
        }
      }
      if (block) {
        NotificationManager.warning('Por favor, escolha uma data de vigência válida!', 'Atenção');
        setInfosClients({ ...infosClients, dtvigencia: null });
      }
    }
  }

  function handleDocumentUpload(files, documentType) {
    if (files.length) {
      // Substituir arquivos ao invés de adicionar (DropzoneArea já envia todos os arquivos)
      setUploadedDocuments((prev) => ({
        ...prev,
        [documentType]: files
      }));
    } else {
      // Se não há arquivos, limpar o tipo de documento
      setUploadedDocuments((prev) => ({
        ...prev,
        [documentType]: []
      }));
    }
  }

  function handleSubmitDocuments() {
    if (selectedBeneficiaries.length === 0) {
      NotificationManager.warning('Selecione um beneficiário!', 'Atenção');
      return;
    }

    // Verificar se pelo menos um arquivo foi selecionado
    const hasAnyFile = Object.values(uploadedDocuments).some((files) => files.length > 0);
    if (!hasAnyFile) {
      NotificationManager.warning('Nenhum documento foi selecionado para upload!', 'Atenção');
      return;
    }

    if (infosClients.statusvenda === 'Aprovada') {
      NotificationManager.warning(
        'Não é possível realizar o upload de documentos em vendas aprovadas!',
        'Atenção'
      );
      return;
    }
    // Preparar dados para envio
    const formData = new FormData();
    formData.append('infos', JSON.stringify(infosClients));
    formData.append('selectedBeneficiaries', JSON.stringify(selectedBeneficiaries));
    formData.append('documentTypes', JSON.stringify(uploadedDocuments));

    // Adicionar arquivos ao FormData
    Object.keys(uploadedDocuments).forEach((docType) => {
      uploadedDocuments[docType].forEach((file, index) => {
        formData.append(`${removeAccents(docType)}_${index}`, file, removeAccents(file.name));
      });
    });

    configAxios
      .post('/uploads/createUploads', formData)
      .then(() => {
        getFilesUploads();
        setUploadedDocuments([]);
        setSelectedBeneficiaries([]);
        setOpenModalDocumentUpload(false);
        NotificationManager.success('Documentos enviados com sucesso!', 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para enviar os documentos, tente novamente!',
          'Atenção'
        );
      });
  }

  function handleImportXls(event) {
    setOpenModalImportLayout(false);
    NotificationManager.success('Importação concluída com sucesso!', 'Sucesso');
  }

  function getRegioes() {
    configAxios
      .get('/products/getRegioesLabel')
      .then((response) => {
        // console.log(response.data);
        setInfosRegioes(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as regiões no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  /**
   * Foi feito dessa forma para submeter
   * somente as mudanças que de fato ocorreram no cadastro
   */
  function HandleSubmit(event) {
    event.preventDefault();
    const infosAddEdit = {
      ...infosClients
    };
    let infosEdit = {};

    if (infoState.id_type_user === 1) {
      if (infosClients.statusvenda === 'Aprovada') {
        NotificationManager.warning('Não é possível editar uma venda aprovada!', 'Atenção');
        return;
      }
    }

    if (infoState.id_type_user === 2) {
      if (infosClients.statusvenda !== 'Aberta') {
        NotificationManager.warning(
          'Não é possível editar uma venda que não esteja aberta!',
          'Atenção'
        );
        return;
      }
    }

    if (infosClients.statusvenda === 'Aguardando cliente' && countSigningDocuments > 0) {
      NotificationManager.warning(
        'Não é possível editar uma venda em que as assinaturas já tenham sido iniciadas!!',
        'Atenção'
      );
      return;
    }

    if (!salesValue && infosClients.titbenef == 'S' && infosClients.id_type_client !== 2) {
      NotificationManager.warning('Por favor, faça o cálculo do valor do beneficiário!', 'Atenção');
      return;
    }

    infosClients.id_user = infosClients.id_user ? infosClients.id_user : infoState.id;
    infosAddEdit.id_user = infosClients.id_user ? infosClients.id_user : infoState.id;

    if (!infosClients.id_user) {
      NotificationManager.warning('Por favor, selecione um vendedor', 'Atenção');
      return;
    }

    if (infoState.id_type_user === 2) {
      infosClients.aceitesmsemail = 'S';
    }
    const router = infosClients.id ? 'clients/updateClient' : 'clients/addClient';

    if (infosClients.id) {
      for (let key in infosAddEdit) {
        if (initialInfosClients[key] === infosAddEdit[key]) {
          if (key !== 'id' && key !== 'codclient' && key !== 'id_user') delete infosAddEdit[key];
        }
      }
    }

    if (
      infosClients.statusvenda === 'Negada' ||
      infosClients.statusvenda === 'Cancelada pelo proponente'
    ) {
      for (let key in infosAddEdit) {
        if (
          key !== 'id' &&
          key !== 'codclient' &&
          key !== 'id_user' &&
          key !== 'motivo_negativa' &&
          key !== 'statusvenda'
        )
          delete infosAddEdit[key];
      }
    }

    if (infosAddEdit.decnascidovivo) {
      if (infosAddEdit.decnascidovivo === 'administrado') {
        infosAddEdit.decnascidovivo = '';
      }
    }

    configAxios
      .post(router, { infosAddEdit, infoState })
      .then((response) => {
        if (response.status === 201) {
          NotificationManager.warning(
            'A proposta foi cadastrada com sucesso, mas tivemos dificuldades para buscar o vendedor, tente novamente!',
            'Atenção'
          );
        }
        NotificationManager.success(
          infosClients.id ? 'Proposta atualizada com sucesso!' : 'Cadastro realizado com sucesso!',
          'Sucesso'
        );
        if (infosClients.id) {
          for (let key in infosAddEdit) {
            if (initialInfosClients[key] !== infosAddEdit[key]) {
              initialInfosClients[key] = infosAddEdit[key];
            }
          }

          setInfosClients({
            ...initialInfosClients,
            codclient: response.data.codclient,
            labelvend: response.data.labelvend ? response.data.labelvend : infosClients.labelvend,
            id: response.data.id,
            tpcontrat: response.data.tpcontrat
          });

          infosEdit = {
            ...initialInfosClients,
            codclient: response.data.codclient,
            id: infosClients.id ? infosClients.id : response.data.id,
            tpcontrat: response.data.tpcontrat
          };
        } else {
          setInfosClients({
            ...infosClients,
            codclient: response.data.codclient,
            labelvend: response.data.labelvend ? response.data.labelvend : infosClients.labelvend,
            id: response.data.id,
            tpcontrat: response.data.tpcontrat
          });

          infosEdit = {
            ...infosClients,
            codclient: response.data.codclient,
            id: infosClients.id ? infosClients.id : response.data.id,
            tpcontrat: response.data.tpcontrat
          };
        }

        key.current = Math.random();

        if (router === 'clients/updateClient') {
          getDependents();
          if (response.data.changedStatus === true) {
            sendMessage();
          }
        }
        const nav = infosClients.id
          ? `/app/editClients/${infosClients.id}`
          : `/app/editClients/${response.data.id}`;
        navigation(nav, {
          state: { infosEdit }
        });
      })
      .catch((error) => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function FormatDate(infos) {
    let dateFormated = formatDate(infos.data.data.datacadastro);
    return dateFormated;
  }

  function RenderidTit(infos) {
    if (infos.data.data.id_tit) {
      return infos.data.data.id_tit;
    }
    return '-';
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          deleteRouter: '/clients/deleteClientDependent',
          deleteItem: infosClients.id_type_client === 1 ? 'o dependente' : 'o beneficiário',
          functionGrid: getDependents,
          functionModal: AddClientsDependentsModal,
          statusvenda: infosClients.statusvenda
        }}
      />
    ));
  }

  function ActionsButtonsUploads(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenuDocuments
        key={item.id}
        infos={{
          id: item.id,
          deleteRouter: '/uploads/deleteUploads',
          deleteItem: 'o documento',
          fileName: item.file,
          company: infosClient,
          id_type_client: infosClients.id_type_client,
          id_client: infosClients.id,
          statusvenda: infosClients.statusvenda,
          functionGrid: getFilesUploads
        }}
      />
    ));
  }

  function AddClientsDependentsModal(id) {
    if (id) {
      const valuesDeps = infosDeps.filter((element) => element.id === id);
      if (valuesDeps.length > 0) {
        const filterTit = infosDeps.filter((element) => element.id === valuesDeps[0].id_tit);
        setInfosDepsTit(filterTit);
      }
      setInfosDepEdit(valuesDeps);
    }
    setOpenModal(true);
  }

  function DiscussionsClientsModal() {
    setOpenModalDiscussion(true);
  }

  function MessagesEntrevisModal() {
    setOpenModalMessagesEntrevis(true);
  }

  function SchedulingClientsModal() {
    setOpenSchedulingClientsModal(true);
  }

  function HistorySalesModal() {
    setOpenModalHistory(true);
  }

  function IntegrationClientsModal() {
    setOpenModalIntegration(true);
  }

  function IntegrationClientModalThird() {
    setOpenModalIntegrationThird(true);
  }

  function IntegrationClientHealthMapModal() {
    setOpenModalIntegrationHealthMap(true);
  }

  function CalculeValuesClient() {
    if (!infosClients.dtnascimento) {
      NotificationManager.warning(
        'Por favor, preencha a data de nascimento para calcular!',
        'Atenção'
      );
      return;
    }
    if (!infosClients.codtab) {
      NotificationManager.warning('Por favor, escolha a tabela para calcular!', 'Atenção');
      return;
    }
    const infosSales = {
      codtab: infosClients.codtab,
      datanascimento: infosClients.dtnascimento
    };
    configAxios
      .post('utilsInfos/calculeSales', infosSales)
      .then((response) => {
        infosClients.valclient = response.data;
        setSalesValue(response.data);
        calculateValuesForSales(infosDeps);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para calcular o plano no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  // Busca o CNS automaticamente via API usando CPF e data de nascimento
  function buscarCNS() {
    if (!infosClients.cpf_cnpj) {
      NotificationManager.warning('Por favor, preencha o CPF antes de buscar o CNS!', 'Atenção');
      return;
    }

    if (!infosClients.dtnascimento) {
      NotificationManager.warning(
        'Por favor, preencha a data de nascimento antes de buscar o CNS!',
        'Atenção'
      );
      return;
    }

    const dataNascimentoFormatada = infosClients.dtnascimento.split('-').reverse().join('/');

    const dadosBusca = {
      cpf: infosClients.cpf_cnpj,
      dataNascimento: dataNascimentoFormatada
    };

    configAxios
      .post('/integration/cns', dadosBusca)
      .then((response) => {
        if (
          response.data.cns &&
          typeof response.data.cns === 'string' &&
          response.data.cns.length === 15
        ) {
          const novosClients = { ...infosClients };
          novosClients.cns = response.data.cns;
          setInfosClients(novosClients);
          NotificationManager.success('CNS encontrado com sucesso!', 'Sucesso');
        } else {
          NotificationManager.warning('CNS não encontrado para os dados informados.', 'Atenção');
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Erro ao buscar CNS. Verifique os dados e tente novamente.',
          'Erro'
        );
      });
  }

  function GeneratePassword() {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz!@#$%&*()_+';
    let string_length = 8;
    let randomstring = '';
    for (let i = 0; i < string_length; i++) {
      let rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }

    const infosUpdate = {
      id: infosClients.id,
      senha: randomstring
    };

    configAxios
      .post('/clients/updatePassword', infosUpdate)
      .then(() => {
        NotificationManager.success('Senha gerada com sucesso!', 'Sucesso');
        setInfosClients({ ...infosClients, senha: randomstring });
        key.current = Math.random();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar a senha, tente novamente!',
          'Atenção'
        );
      });
  }

  function handleTabsChange(event, newValue) {
    setValues(newValue);
  }

  function ActionsButtonsAddress(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          router: 'editClients',
          deleteRouter: '/address/deleteAddress',
          deleteItem: 'o endereço',
          functionGrid: getAddress,
          otherInfos: item,
          functionModal: AddAddressModal,
          statusvenda: infosClients.statusvenda
        }}
      />
    ));
  }

  function HandleMaintenanceSales() {
    if (infoState.id_type_user === 1 && infoState.id_profile === 1) {
      setOpenMaintenance(true);
    }
  }

  function HandleUpdateEmail(event) {
    if (infosClients.id) {
      if (validEmail(event.target.value)) {
        const wEmail = event.target.name;
        if (event && initialInfosClients[wEmail] !== event.target.value) {
          const infosUpdate = {
            id: infosClients.id,
            [event.target.name]: event.target.value,
            user_id: infoState.id
          };
          configAxios
            .post('/clients/updateEmailClient', infosUpdate)
            .then(() => {
              NotificationManager.success('Email atualizado com sucesso!', 'Sucesso');
              setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
              initialInfosClients[wEmail] = event.target.value;
            })
            .catch(() => {
              NotificationManager.error(
                'Tivemos dificuldades para atualizar o email, tente novamente!',
                'Atenção'
              );
            });
        }
      } else {
        NotificationManager.error(
          'Email inválido, por favor, verifique e tente novamente!',
          'Atenção'
        );
      }
    }
  }

  function HandleUpdateDeclinio(event) {
    if (infosClients.id) {
      const wDeclinio = event.target.name;
      if (event && initialInfosClients[wDeclinio] !== event.target.value) {
        const infosUpdate = {
          id: infosClients.id,
          [event.target.name]: event.target.value,
          user_id: infoState.id
        };
        configAxios
          .post('/clients/updateDeclinio', infosUpdate)
          .then(() => {
            NotificationManager.success('Observações atualizadas com sucesso!', 'Sucesso');
            setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
            initialInfosClients[wDeclinio] = event.target.value;
          })
          .catch(() => {
            NotificationManager.error(
              'Tivemos dificuldades para atualizar as observações, tente novamente!',
              'Atenção'
            );
          });
      }
    }
  }

  function selectedRows(event) {
    setRowsSelected(event.selectedRowsData);
  }

  async function downloadFilesUploads() {
    const tpbenef = infosClients.id_type_client === 1 ? 'fisico' : 'juridico';
    const URL_AWS_S3 = 'https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com';
    const zip = new JSZip();
    dispatch(startAndStop(true));

    for (let element of rowsSelected) {
      let url = `${URL_AWS_S3}/${company}/${tpbenef}/${infosClients.id}/${element.file}`;
      await fetch(url, {
        method: 'GET'
      })
        .then((res) => {
          return res.blob();
        })
        .then((blob) => {
          var file = new File([blob], element.file);
          zip.file(element.file, file, { base64: false });
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para gerar o download dos arquivos, tente novamente!',
            'Atenção'
          );
        });
    }

    dispatch(startAndStop(false));

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      const zipblob = new Blob([content]);
      download(zipblob, `${infosClients.nome} - uploads.zip`);
    });
  }

  function openModalDeleteDeclarationHealth() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para excluir a declaração de saúde!',
        'Atenção'
      );
      return;
    }
    if (rowSelected.completedhealthdeclaration === false) {
      NotificationManager.warning(
        'Declaração ainda não preenchida, selecione o botão preencher para preenche-la!',
        'Atenção'
      );
      return;
    }

    setModalDeleteOpen(true);
  }

  function HandleDeleteDeclarationHealth() {
    const flag = rowSelected.flag ? 'tb_clients' : 'tb_clients_dep';

    configAxios
      .delete(`/questions/deleteResponseDeclarationHealth/${rowSelected.id}/${flag}`)
      .then(() => {
        setModalDeleteOpen(false);
        getInfosclients(infoState);

        NotificationManager.success('Declaração de saúde excluída com sucesso!', 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para excluir a declaração de saúde, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleDownloadPdfDocument() {
    configAxios
      .get(`/clients/downloadPdfDocument/${infosClients.id}`, {
        responseType: 'blob'
      })
      .then((result) => {
        const blob = URL.createObjectURL(result.data);
        setDownloadPdf(blob);
        setOpenModalDownloadPdf(true);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar o documento. Tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleReciboPdfDocument() {
    configAxios
      .get(`/clients/HandleReciboPdfDocument/${infosClients.id}`, {
        responseType: 'blob'
      })
      .then((result) => {
        const blob = URL.createObjectURL(result.data);
        setDownloadPdf(blob);
        setOpenModalDownloadPdf(true);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar o documento. Tente novamente!',
          'Atenção'
        );
      });
  }

  function selectRowsDownload(event) {
    setRowsDownload(event.selectedRowsData);
  }

  async function getDocumentsDownload() {
    let clientForSignatureDocuments = {};

    clientForSignatureDocuments = {
      tpcontrat: infosClients.tpcontrat,
      id_client: infosClients.id,
      codplano: infosClients.codplano
    };

    configAxios
      .post(`/signing/getDocumentsForDownload`, clientForSignatureDocuments)
      .then((result) => {
        setDocumentsDownload(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os documentos para download, tente novamente!',
          'Atenção'
        );
      });
  }

  async function downloadDocuments() {
    const zip = new JSZip();

    rowsSelectedDownload.map((element) => {
      element.tpbenef = infosClients.id_type_client === 1 ? 'fisico' : 'juridico';
      element.id_client = infosClients.id;
      element.codcontrato = infosClients.codcont;
      // ? infosClients.codcontrato_plano
      // : user.userLoggedIn[0].codcontrato_plano;
    });

    configAxios
      .post(`/forms/downloadAllDocumentos`, rowsSelectedDownload)
      .then((result) => {
        const data = result.data;
        for (let element of data) {
          const blob = new Blob([new Uint8Array(element.data.data)], { type: 'application/pdf' });

          var file = new File([blob], element.file);
          zip.file(element.file, file, { base64: false });
        }
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          const zipblob = new Blob([content]);
          download(zipblob, `${infosClients.nome} - assinados.zip`);
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os documentos para download, tente novamente!',
          'Atenção'
        );
      });
  }

  function deleteClaims() {
    const tempInfosPost = [];
    tempInfosPost.push(rowSelected);
    let tableUpdateClaim;
    if (rowSelected.claim === false) {
      NotificationManager.warning(
        'Não há agravos para serem excluído(s) para o beneficiário selecionado!',
        'Atenção'
      );
      return;
    }
    tempInfosPost.map((claim) => {
      if (claim.tpbenef == 'Titular') {
        claim.tpbenef = 1;
        claim.id_client = rowSelected.id;
        claim.id_dep = null;
        if (infosClients.tpcontrat !== '2-COLETIVO EMPRESARIAL') {
          tableUpdateClaim = 'tb_declaration_health_clients_resp';
        } else {
          tableUpdateClaim = 'tb_declaration_health_clients_dep_resp';
          claim.id_client = infosClients.id;
          claim.id_dep = rowSelected.id;
        }
      } else {
        claim.tpbenef = 2;
        claim.id_client = infosClients.id;
        claim.id_dep = rowSelected.id;
        tableUpdateClaim = 'tb_declaration_health_clients_dep_resp';
      }
    });
    const infosPost = {
      infosClaims: tempInfosPost,
      tableUpdateClaim: tableUpdateClaim
    };
    configAxios
      .post('/claims/deleteClaims', infosPost)
      .then(() => {
        NotificationManager.success('Agravos excluídos com sucesso!', 'Sucesso');
        setOpenModalDeleteClaim(false);
        setInfosClaims([]);
        getInfosclients();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para excluir os agravos, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function ModalHandleDeleteClaim(popupState) {
    return (
      <BootstrapDialog
        onClose={() => setOpenModalDeleteClaim(false)}
        aria-labelledby="customized-dialog-title"
        open={openModalDeleteClaim}>
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => setOpenModalDeleteClaim(false)}>
          Confirmação de exclusão
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom variant="subtitle2">
            Deseja realmente excluir o(s) agravo(s) do beneficiário selecionado?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => deleteClaims()}
            color="success"
            variant="contained"
            startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
            Sim
          </Button>
          <Button
            onClick={() => setOpenModalDeleteClaim(false)}
            color="error"
            variant="contained"
            startIcon={<Iconify icon="eva:close-circle-fill" />}>
            Não
          </Button>
        </DialogActions>
      </BootstrapDialog>
    );
  }

  function downloadDeclarationOfHealthPdf() {
    configAxios
      .post(
        `/questions/downloadDeclarationOfHealthPdf`,
        {
          codclient: infosClients.codclient,
          id_client: infosClients.id
        },
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        if (response.status === 202) {
          NotificationManager.warning(
            'Não encontramos informações para os parâmetros selecionados!',
            'Atenção'
          );
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Apontamentos declaração de saúde - ${infosClients.codclient}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar o documento! Por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  async function getInfosclients() {
    const router =
      infosClients.id_type_client === 1
        ? `/clients/getInfosSignaturePF/${infosClients.id}`
        : `/clients/getInfosSignaturePJ/${infosClients.id}/null/resp_jur`;

    await configAxios
      .get(router)
      .then((result) => {
        if (infosClients.id_type_client === 1) {
          infosPF.current = result.data.client;
          setInfosClientsHealth(result.data.health);
        }
        if (infosClients.id_type_client === 2) {
          infosPJ.current = result.data.client;
          setInfosClientsHealth(result.data.health);
        }
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function RenderHealth(infos) {
    if (infos.data.data.completedhealthdeclaration) {
      return 'Sim';
    }
    return 'Não';
  }

  function RenderClaim(infos) {
    if (infos.data.data.claim === true) {
      return 'Sim';
    }
    return 'Não';
  }

  function addDeclarationHealthModal() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para preencher a declaração de saúde!',
        'Atenção'
      );
      return;
    }
    if (rowSelected.completedhealthdeclaration === true) {
      NotificationManager.warning(
        'Declaração já preenchida, selecione o botão visualizar para visualizar a declaração!',
        'Atenção'
      );
      return;
    }
    setOpenModalDeclarationHealth(true);
  }

  function addEditClaimsModal(popupState, edit) {
    popupState.close();
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o(a) beneficiário(a) para preencher a CPT (Cobertura parcial temporária)',
        'Atenção'
      );
      return;
    }
    if (rowSelected.completedhealthdeclaration === false) {
      NotificationManager.warning(
        'Declaração ainda não preenchida, não é possível preencher a CPT (Cobertura parcial temporária) do(a) beneficiário(a)',
        'Atenção'
      );
      return;
    }
    if (rowSelected.claim === true && edit.edit === true) {
      let url = `/claims/getClaims/${infosClients.id}/${rowSelected.id}`;
      if (rowSelected.tpbenef == 'Titular') {
        if (infosClients.tpcontrat !== '2-COLETIVO EMPRESARIAL') {
          url = `/claims/getClaims/${rowSelected.id}`;
        } else {
          url = `/claims/getClaims/${infosClients.id}/${rowSelected.id}`;
        }
      }
      configAxios
        .get(url)
        .then((result) => {
          setInfosClaims(result.data);
        })
        .catch((error) => {
          NotificationManager.error(
            'Tivemos dificuldades para buscar as informações da CPT, tente novamente!',
            'Atenção'
          );
          return;
        });
    } else if (edit.edit === true) {
      NotificationManager.warning(
        'Beneficiário(a) sem CPT (Cobertura parcial temporária) preenchida, verifique!',
        'Atenção'
      );
      return;
    } else if (edit.edit === false && rowSelected.claim === true) {
      NotificationManager.warning(
        'Beneficiário(a) já possui CPT (Cobertura parcial temporária) preenchida!',
        'Atenção'
      );
      return;
    }
    setOpenModalClaims(true);
  }

  return (
    <RenderPage title="Vendas">
      <>
        <div>
          <BootstrapDialog
            onClose={() => {
              setModalDeleteOpen(false);
              getInfosclients(infoState);
            }}
            aria-labelledby="customized-dialog-title"
            fullWidth
            maxWidth={'sm'}
            PaperProps={{
              sx: { borderRadius: 0 }
            }}
            open={modalDeleteOpen}>
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={() => {
                setModalDeleteOpen(false);
              }}>
              Excluir declaração de saúde
            </BootstrapDialogTitle>

            <DialogContent dividers>
              <Typography variant="subtitle2">
                Deseja realmente excluir a declaração de saúde?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => {
                  HandleDeleteDeclarationHealth();
                }}
                color="success"
                startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
                Sim
              </Button>
              <Button
                onClick={() => {
                  setModalDeleteOpen(false);
                  getInfosclients(infoState);
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Não
              </Button>
            </DialogActions>
          </BootstrapDialog>
        </div>

        {infosClients.statusvenda === 'Aguardando cliente' && (
          <PendingHealthDeclaration
            openModal={openModalPendingHealth}
            setOpenModal={setOpenModalPendingHealth}
            pendingInfos={pendingInfosDeclarationHealth}
            functionGrid={getDependents}
            headerModalPending={headerModalPending}
          />
        )}

        <ReactShortcut keys="ctrl+M" onKeysPressed={HandleMaintenanceSales} />

        <AddEditAddress
          openModal={openModalAddress}
          otherInfos={infosClients}
          infosItemEdit={infosAdressEdit}
          countSigningDocuments={countSigningDocuments}
          setOpenModal={setOpenModalAddress}
          functionGrid={getAddress}
        />

        <ShowDocuments
          openModal={openModalDownloadPdf}
          url={downloadPdf}
          setOpenModal={setOpenModalDownloadPdf}
        />

        <AddEditClientsDependents
          openModal={openModal}
          otherInfos={infosClients}
          infosDeps={infosDeps}
          infosDepsEdit={infosDepsEdit}
          infosDepsTit={infosDepsTit}
          infosPlans={infosPlans}
          infosTables={infosTables}
          countSigningDocuments={countSigningDocuments}
          setOpenModal={setOpenModal}
          functionGrid={getDependents}
        />

        <SendEmailDocuments
          openModal={openModalSendEmailDocuments}
          setOpenModal={setOpenModalSendEmailDocuments}
          functionGetHistory={getHistoryEmails}
          infosClients={infosClients}
          infosDeps={infosDeps}
          infosHistoryEmail={infosHistoryEmail}
          infoState={infoState}
          infosClient={infosClient}
          key={value}
        />

        <SendWelcome
          openModal={openModalsendWelcome}
          setOpenModal={setOpenModalsendWelcome}
          infosClients={infosClients}
          key={value}
        />

        <SendWhatsAppDocuments
          openModal={openModalSendWhatsAppDocuments}
          setOpenModal={setOpenModalSendWhatsAppDocuments}
          functionGetHistory={getHistoryWhatsApp}
          infosClients={infosClients}
          infosDeps={infosDeps}
          infosHistoryWhatsApp={infosHistoryWhastApp}
          infoState={infoState}
          infosClient={infosClient}
          key={valueWhatsApp}
        />

        <HistorySales
          openModal={openModalHistory}
          setOpenModal={setOpenModalHistory}
          infosClients={infosClients}
          infosHistorySales={infosHistorySales}
        />

        <MaintenanceClients
          openModal={openMaintenance}
          setOpenModal={setOpenMaintenance}
          infosClients={infosClients}
          getInfosClient={getInfosClient}
          getHistorySales={getHistorySales}
          getCountDocumentsSigning={getCountDocumentsSigning}
        />

        {infosClients.statusvenda === infoState.statusintegracao && (
          <IntegrationClients
            openModal={openModalIntegration}
            setOpenModal={setOpenModalIntegration}
            infosClients={infosClients}
            infosDeps={infosDeps}
            infosAddress={infosAddress}
            infosContract={infosContract}
            infosHistoryIntegration={infosHistoryIntegration}
            getHistoryIntegration={getHistoryIntegration}
          />
        )}

        {infosClients.statusvenda === infoState.statusintegracao &&
          infoState.integraterceiros === 'Sim' && (
            <IntegrationClientsThird
              openModal={openModalIntegrationThird}
              setOpenModal={setOpenModalIntegrationThird}
              infosClients={infosClients}
              infosDeps={infosDeps}
              infosAddress={infosAddress}
              infosContract={infosContract}
              infosHistoryIntegration={infosHistoryIntegrationThird}
              getHistoryIntegration={getHistoryIntegrationThird}
            />
          )}
        {infosClients.statusvenda === 'Realizar entrevista' &&
          infoState.integhealthmap === 'Sim' &&
          infoState.id_type_user === 1 && (
            <IntegrationHealthMap
              openModal={openModalIntegrationHealthMap}
              setOpenModal={setOpenModalIntegrationHealthMap}
              infosClients={infosClients}
              infosDeps={infosDeps}
              infosAddress={infosAddress}
              infosHistoryIntegration={infosHistoryHealthMap}
              getHistoryIntegration={getHistoryHealthMap}
            />
          )}
        <DiscussionClients
          openModal={openModalDiscussions}
          key={valueKeys}
          otherInfos={infosClients}
          getCountMessages={getCountMessages}
          sendMessage={sendMessage}
          setOpenModal={setOpenModalDiscussion}
        />

        <MessagesEntrevis
          openModal={openModalMessagesEntrevis}
          key={valueKeysEntrevis}
          otherInfos={infosClients}
          getCountMessages={getCountMessagesEntrevis}
          setOpenModal={setOpenModalMessagesEntrevis}
        />

        <SchedulingClients
          openModal={openSchedulingClientsModal}
          setOpenModal={setOpenSchedulingClientsModal}
          otherInfos={infosClients}
        />

        {/* <AddEditDeclarationHealth
          openModal={openModalDeclarationHealth}
          setOpenModal={setOpenModalDeclarationHealth}
          showDeclaration={showDeclaration}
          setShowDeclaration={setShowDeclaration}
          responseQuestions={responseQuestions}
          functionGrid={getInfosContract}
          infosAskQuestions={infosQuestions}
          rowSelected={rowSelected}
          statusvenda={infosClients.statusvenda}
        /> */}

        <AddEditDeclarationHealth
          openModal={openModalDeclarationHealth}
          setOpenModal={setOpenModalDeclarationHealth}
          showDeclaration={showDeclaration}
          setShowDeclaration={setShowDeclaration}
          responseQuestions={responseQuestions}
          functionGrid={getInfosclients}
          infosAskQuestions={infosQuestions}
          rowSelected={rowSelected}
          controlaMudancaCarencia={infoState.controlamudancacarencia}
          // statusvenda={
          //   infosPJ.current.statusvenda !== '' && typeClient !== 'resp_jur'
          //     ? infosPJ.current.statusvenda
          //     : infosClients[0].statusvenda
          // }
        />

        {/* Modal de Indicadores do Contrato */}
        <ContractIndicators
          openModal={openModalIndicators}
          setOpenModal={setOpenModalIndicators}
          clientId={infosClients.id}
          otherInfos={infosClients}
        />

        <AddEditClaims
          openModal={openModalClaims}
          setOpenModal={setOpenModalClaims}
          infosClients={infosClients}
          functionGrid={getInfosclients}
          rowSelected={rowSelected}
          infosClaims={infosClaims}
        />

        <ModalHandleDeleteClaim />

        {isMobile && (
          <>
            <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
              <Grid container>
                <BreadcrumbsNav {...props} />
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h4" gutterBottom>
                    Cadastro de propostas
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    Utilize as opções abaixo para inserir e editar as propostas
                  </Typography>
                </Grid>
                {infosClients.id &&
                  infosClients.statusvenda === 'Aberta' &&
                  infoState.id_type_user === 2 && (
                    <Alert severity="info">
                      Prezado(a), não se esqueça de mudar o status da venda para análise para que a
                      mesma possa prosseguir!
                    </Alert>
                  )}
                {infosClients.allow_additive === 'S' && (
                  <Alert severity="danger">**Atenção, venda na modalidade aditivo</Alert>
                )}
              </Grid>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" mb={2}>
              {infoState.welcome_send === 'Sim' &&
                infosClients.statusvenda === 'aprovada' &&
                infoState.id_type_user === 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      setOpenModalSendEmailDocuments(true);
                    }}
                    startIcon={<Iconify icon="eva:email-outline" />}>
                    Reenviar boas vindas
                  </Button>
                )}
              {((infoState.id_type_user === 1 &&
                infosClients.id &&
                infoState.gerarecibo === 'Sim') ||
                (infosClients.id &&
                  infoState.gerarecibo === 'Sim' &&
                  infoState.name_broker === 'ASSCOMBRAS' &&
                  (infoState.coduser === '00021' || infoState.coduser === '00192') &&
                  // eslint-disable-next-line
                  infosClients.statusvenda !== 'Aberta' &&
                  // eslint-disable-next-line
                  infosClients.statusvenda !== 'Negada' &&
                  infosClients.statusvenda !== 'Cancelada pelo proponente')) && (
                <Button
                  sx={{ mr: 1 }}
                  variant="outlined"
                  color="primary"
                  component={RouterLink}
                  onClick={() => {
                    HandleReciboPdfDocument();
                  }}
                  startIcon={<Iconify icon="eva:file-text-outline" />}>
                  Recibo
                </Button>
              )}
              {(infosClients.statusvenda === 'Aguardando cliente' ||
                infosClients.statusvenda === 'Aguardando CPT(s)') &&
                infosClients.id &&
                infoState.id_type_user === 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      setOpenModalsendWelcome(true);
                    }}
                    startIcon={<Iconify icon="eva:email-outline" />}>
                    Enviar
                  </Button>
                )}
              {(infosClients.statusvenda === 'Aguardando cliente' ||
                infosClients.statusvenda === 'Aguardando CPT(s)') &&
                infosClients.id &&
                infoState.id_type_user === 1 &&
                infoState.solicitawhatsapp === 'Sim' && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      setOpenModalSendWhatsAppDocuments(true);
                    }}
                    startIcon={<Iconify icon="eva:paper-plane-fill" />}>
                    Enviar
                  </Button>
                )}
              {infosClients.statusvenda === 'Aprovada' &&
                infosClients.id &&
                infoState.id_type_user === 1 &&
                infoState.tipooperacao === 'Administradora' && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      HandleDownloadPdfDocument();
                    }}
                    startIcon={<Iconify icon="eva:file-text-outline" />}>
                    Proposta
                  </Button>
                )}
              {infosClients.id && (
                <>
                  {infoState.entrevisqualificada === 'Sim' && infoState.id_type_user === 1 && (
                    <Badge
                      color="error"
                      badgeContent={
                        countMessagesEntrevis.count > 0 ? countMessagesEntrevis.count : null
                      }
                      max={50}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}>
                      <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        onClick={() => {
                          MessagesEntrevisModal();
                        }}
                        startIcon={<Iconify icon="eva:message-circle-outline" />}>
                        Mensagens
                      </Button>
                    </Badge>
                  )}
                  {infoState.id_profile !== 4 && (
                    <Badge
                      color="error"
                      badgeContent={countMessages.count > 0 ? countMessages.count : null}
                      max={50}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}>
                      <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        onClick={() => {
                          DiscussionsClientsModal();
                        }}
                        startIcon={<Iconify icon="eva:message-circle-fill" />}>
                        Discussões
                      </Button>
                    </Badge>
                  )}
                  {!isMobile && infoState.id_type_user === 1 && (
                    <>
                      <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        onClick={() => {
                          HistorySalesModal();
                        }}
                        startIcon={<ManageHistoryIcon />}>
                        Histórico
                      </Button>
                      {infosClients.statusvenda === 'Aguardando cliente' &&
                        infoState.id_profile !== 4 && (
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            color="primary"
                            component={RouterLink}
                            onClick={() => {
                              PendingHealthDeclarationAndSigning();
                            }}
                            startIcon={<Iconify icon="eva:alert-triangle-outline" />}>
                            Pendências
                          </Button>
                        )}
                    </>
                  )}
                  {!isMobile &&
                    infoState.id_type_user === 1 &&
                    infoState.entrevisqualificada === 'Sim' &&
                    infosClients.statusvenda === 'Realizar entrevista' && (
                      <Badge
                        color="error"
                        badgeContent={
                          countMessagesEntrevis.count > 0 ? countMessagesEntrevis.count : null
                        }
                        max={50}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'left'
                        }}>
                        <Button
                          sx={{ mr: 1 }}
                          variant="contained"
                          color="primary"
                          component={RouterLink}
                          onClick={() => {
                            MessagesEntrevisModal();
                          }}
                          startIcon={<Iconify icon="eva:message-circle-outline" />}>
                          Mensagens
                        </Button>
                      </Badge>
                    )}
                </>
              )}
            </Stack>
          </>
        )}
        {!isMobile && (
          <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
            <Grid container>
              <BreadcrumbsNav {...props} />
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h4" gutterBottom>
                  Cadastro de propostas
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Utilize as opções abaixo para inserir e editar as propostas
                </Typography>
              </Grid>
              {infosClients.statusvenda === infoState.statusintegracao &&
                infoState.id_type_user === 1 &&
                infoState.tipointegracao !== 'Não possui' && (
                  <Alert severity={resultIntegration.length ? 'success' : 'warning'}>
                    Status da integração: {resultIntegration.length ? 'integrada' : 'aguardando'}
                  </Alert>
                )}
              {infosClients.statusvenda === infoState.statusintegracao &&
                infoState.id_type_user === 1 &&
                infoState.tipointegracao !== 'Não possui' &&
                infoState.integraterceiros === 'Sim' && (
                  <Alert severity={resultIntegrationThird.length ? 'success' : 'warning'}>
                    Status da integração com terceiros:{' '}
                    {resultIntegrationThird.length ? 'integrada' : 'aguardando'}
                  </Alert>
                )}
              {parametrosAlerta.show && infoState.id_type_user === 1 && (
                <Alert severity="warning" sx={{ mb: 2, mt: 3 }}>
                  {parametrosAlerta.message}
                </Alert>
              )}
              {infosClients.id && infosClients.statusvenda === 'Aberta' && (
                <Alert severity="info">
                  Prezado(a), não se esqueça de mudar o status da venda para análise para que a
                  mesma possa prosseguir!
                </Alert>
              )}
              {infosClients.allow_additive === 'S' && (
                <Alert severity="error">
                  Atenção: venda na modalidade aditivo, só é possível inserir dependentes
                </Alert>
              )}
            </Grid>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              {infoState.welcome_send === 'Sim' &&
                infosClients.statusvenda === 'Aprovada' &&
                infoState.id_type_user === 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ textTransform: 'none', mr: 1 }}
                    onClick={() => {
                      setOpenModalsendWelcome(true);
                    }}
                    startIcon={<Iconify icon="eva:email-outline" />}>
                    <Typography noWrap sx={{ fontWeight: 'bold' }}>
                      Reenviar boas vindas
                    </Typography>
                  </Button>
                )}
              {((infoState.id_type_user === 1 &&
                infosClients.id &&
                infoState.gerarecibo === 'Sim') ||
                (infosClients.id &&
                  infoState.gerarecibo === 'Sim' &&
                  infoState.name_broker === 'ASSCOMBRAS' &&
                  (infoState.coduser === '00021' || infoState.coduser === '00192') &&
                  // eslint-disable-next-line
                  infosClients.statusvenda !== 'Aberta' &&
                  // eslint-disable-next-line
                  infosClients.statusvenda !== 'Negada' &&
                  infosClients.statusvenda !== 'Cancelada pelo proponente')) && (
                <Button
                  sx={{ mr: 1 }}
                  variant="outlined"
                  color="primary"
                  component={RouterLink}
                  onClick={() => {
                    HandleReciboPdfDocument();
                  }}
                  startIcon={<Iconify icon="eva:file-text-outline" />}>
                  Recibo
                </Button>
              )}
              {(infosClients.statusvenda === 'Aguardando cliente' ||
                infosClients.statusvenda === 'Aguardando CPT(s)') &&
                infosClients.id &&
                infoState.id_type_user === 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      setOpenModalSendEmailDocuments(true);
                    }}
                    startIcon={<Iconify icon="eva:email-outline" />}>
                    Enviar
                  </Button>
                )}
              {(infosClients.statusvenda === 'Aguardando cliente' ||
                infosClients.statusvenda === 'Aguardando CPT(s)') &&
                infosClients.id &&
                infoState.id_type_user === 1 &&
                infoState.solicitawhatsapp === 'Sim' && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    sx={{ mr: 1 }}
                    onClick={() => {
                      setOpenModalSendWhatsAppDocuments(true);
                    }}
                    startIcon={<Iconify icon="eva:paper-plane-fill" />}>
                    Enviar
                  </Button>
                )}
              {infosClients.id && (
                <>
                  {infosClients.statusvenda === 'Aprovada' &&
                    infosClients.id &&
                    infoState.id_type_user === 1 &&
                    infoState.tipooperacao === 'Administradora' && (
                      <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        sx={{ mr: 1 }}
                        onClick={() => {
                          // setOpenModalSendEmailDocuments(true);
                          HandleDownloadPdfDocument();
                        }}
                        startIcon={<Iconify icon="eva:file-text-outline" />}>
                        Proposta
                      </Button>
                    )}
                  {infoState.entrevisqualificada === 'Sim' && infoState.id_type_user === 1 && (
                    <>
                      <Badge
                        color="error"
                        badgeContent={
                          countMessagesEntrevis.count > 0 ? countMessagesEntrevis.count : null
                        }
                        max={50}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'left'
                        }}>
                        <Button
                          sx={{ mr: 1 }}
                          variant="contained"
                          color="primary"
                          component={RouterLink}
                          onClick={() => {
                            MessagesEntrevisModal();
                          }}
                          startIcon={<Iconify icon="eva:message-circle-outline" />}>
                          Mensagens
                        </Button>
                      </Badge>
                      {infoState.id_profile === 4 && infosClients.id_type_client === 1 && (
                        <Button
                          sx={{ mr: 1 }}
                          variant="contained"
                          color="primary"
                          component={RouterLink}
                          onClick={() => {
                            SchedulingClientsModal();
                          }}
                          startIcon={<Iconify icon="eva:calendar-outline" />}>
                          Agendamento
                        </Button>
                      )}
                    </>
                  )}
                  {infoState.id_profile !== 4 && (
                    <Badge
                      color="error"
                      badgeContent={countMessages.count > 0 ? countMessages.count : null}
                      max={50}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}>
                      <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        onClick={() => {
                          DiscussionsClientsModal();
                        }}
                        startIcon={<Iconify icon="eva:message-circle-fill" />}>
                        Discussões
                      </Button>
                    </Badge>
                  )}
                  {infoState.id_type_user === 1 && (
                    <>
                      <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        onClick={() => {
                          HistorySalesModal();
                        }}
                        startIcon={<ManageHistoryIcon />}>
                        Histórico
                      </Button>
                      {infosClients.statusvenda === 'Aguardando cliente' &&
                        infoState.id_profile !== 4 && (
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            color="primary"
                            component={RouterLink}
                            onClick={() => {
                              PendingHealthDeclarationAndSigning();
                            }}
                            startIcon={<Iconify icon="eva:alert-triangle-outline" />}>
                            Pendências
                          </Button>
                        )}
                      {infosClients.statusvenda === infoState.statusintegracao &&
                        infoState.tipointegracao !== 'Não possui' && (
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            color="primary"
                            component={RouterLink}
                            onClick={() => {
                              IntegrationClientsModal();
                            }}
                            startIcon={<Iconify icon="eva:cloud-upload-fill" />}>
                            Integração
                          </Button>
                        )}
                      {infosClients.statusvenda === infoState.statusintegracao &&
                        infoState.integraterceiros === 'Sim' && (
                          // infosClients.tpcontrat !== '2-COLETIVO EMPRESARIAL' && (
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            color="primary"
                            component={RouterLink}
                            onClick={() => {
                              IntegrationClientModalThird();
                            }}
                            startIcon={<Iconify icon="eva:cloud-upload-fill" />}>
                            Terceiros
                          </Button>
                        )}
                      {!isMobile &&
                        infoState.id_type_user === 1 &&
                        infoState.integhealthmap === 'Sim' &&
                        infosClients.statusvenda === 'Realizar entrevista' && (
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            color="primary"
                            component={RouterLink}
                            onClick={() => {
                              IntegrationClientHealthMapModal();
                            }}
                            startIcon={<Iconify icon="eva:activity-outline" />}>
                            <Typography noWrap sx={{ fontWeight: 'bold' }}>
                              Integrar HealthMap
                            </Typography>
                          </Button>
                        )}
                    </>
                  )}
                </>
              )}
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/clients"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </Stack>
          </Stack>
        )}
        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box sx={{ width: '100%', border: 1, borderColor: 'grey.200', p: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                  }}>
                  <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                  {infosClients.tpcontrat_client === '2-COLETIVO EMPRESARIAL' && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="medium"
                      startIcon={<Iconify icon="eva:bar-chart-2-fill" />}
                      onClick={() => setOpenModalIndicators(true)}>
                      Indicadores
                    </Button>
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                  }}>
                  {infosDaysTerms.length > 0 && infoState.id_profile !== 4 && (
                    <Alert severity="info">
                      Dias de vigências disponíveis: {'    '}
                      {infosDaysTerms.map((day) => `[${day.dia}|${day.dia_corte}]`).join(', ')}
                    </Alert>
                  )}
                </Box>
                {infosClients.id && infosClients.hash_envelope && (
                  <Alert severity="info" sx={{ fontWeight: 'bold' }}>
                    Hash do envelope de assinatura: {infosClients.hash_envelope}
                  </Alert>
                )}
                <Grid container spacing={2} sx={{ mb: 0 }}>
                  {infosClients.id && (
                    <>
                      <Grid item xs={12} md={1} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                        <TextField
                          name="id"
                          fullWidth
                          label="ID"
                          variant="outlined"
                          size="small"
                          required
                          disabled
                          value={infosClients.id || ''}
                        />
                      </Grid>
                      {infosClients.codclient && (
                        <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                          <TextField
                            name="codclient"
                            fullWidth
                            label="Código do cliente"
                            variant="outlined"
                            size="small"
                            required
                            disabled
                            value={infosClients.codclient || ''}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {infosClients.id && !infosClients.codsimulation && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                      <TextField
                        name="codsimulation"
                        fullWidth
                        label="Código da simulação"
                        variant="outlined"
                        size="small"
                        disabled={true}
                        value="-"
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={(event) => HandleGetSimulation(event)}
                      />
                    </Grid>
                  )}
                  {infosClients.id && infosClients.codsimulation && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                      <TextField
                        name="codsimulation"
                        fullWidth
                        label="Código da simulação"
                        variant="outlined"
                        size="small"
                        disabled={true}
                        value={infosClients.codsimulation}
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={(event) => HandleGetSimulation(event)}
                      />
                    </Grid>
                  )}
                  {!infosClients.id && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                      <TextField
                        name="codsimulation"
                        fullWidth
                        label="Código da simulação"
                        variant="outlined"
                        size="small"
                        disabled={false}
                        value={infosClients.codsimulation || ''}
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={(event) => HandleGetSimulation(event)}
                      />
                    </Grid>
                  )}
                  {infoState.tipointegracao === 'Não possui' &&
                    infosClients.id &&
                    infosClients.statusvenda !== 'Aberta' &&
                    infoState.controlacontrato === 'Sim' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                        <TextField
                          name="codcontrato"
                          fullWidth
                          label="Código do contrato"
                          variant="outlined"
                          size="small"
                          disabled={infoState.id_type_user === 1 ? false : true}
                          required
                          value={infosClients.codcontrato || ''}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                    )}
                  {infoState.controlaregiao === 'Sim' && (
                    <Grid item xs={12} md={3} sx={isMobile ? { mt: 0 } : { mt: 4.2 }}>
                      <Autocomplete
                        sx={isMobile ? { mt: 1 } : { mt: 0 }}
                        options={infosRegioes}
                        renderOption={(props, option) => <li {...props}>{option.label}</li>}
                        isOptionEqualToValue={(option, value) =>
                          value ? option.label === value : option.label === ''
                        }
                        onChange={(event, value) => HandleInputChange(value, { regiao: true })}
                        value={infosClients.labelregiao || ''}
                        defaultValue=""
                        disabled={infosClients.id ? true : false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Região da comercialização"
                            name="idregiao"
                            fullWidth
                            size="small"
                            variant="outlined"
                            disabled={infosClients.id ? true : false}
                            required
                          />
                        )}
                      />
                    </Grid>
                  )}
                  {infoState.tipointegracao !== 'Não possui' &&
                    infosClients.id &&
                    (infosClients.statusvenda === infoState.statusintegracao ||
                      infosClients.statusvenda !== 'Aberta') &&
                    infoState.controlacontrato === 'Sim' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                        <TextField
                          name="codcontrato"
                          fullWidth
                          label="Código do contrato"
                          variant="outlined"
                          size="small"
                          disabled={infoState.id_type_user === 1 ? false : true}
                          onBlur={(event) => HandleChangeCodContract(event)}
                          // required
                          value={infosClients.codcontrato || ''}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                    )}
                  {company === 'higiasaude' && infosClients.id_type_client === 2 && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Formato da venda *
                      </InputLabel>
                      <Select
                        name="formato"
                        fullWidth
                        size="small"
                        required
                        value={infosClients.formato || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'1-29'}>De 1 a 29 vidas</MenuItem>
                        <MenuItem value={'30-99'}>De 30 a 99 vidas</MenuItem>
                      </Select>
                    </Grid>
                  )}
                  {infoState.controlacaepf === 'Sim' && (
                    <Grid item xs={12} md={2} sx={isMobile ? {} : { mt: 4.2 }}>
                      <TextField
                        name="dtvigencia"
                        label="Data da vigência"
                        fullWidth
                        type="date"
                        required
                        variant="outlined"
                        size="small"
                        value={infosClients.dtvigencia || ''}
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={() => validDtvigencia()}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={2} sx={isMobile ? {} : { mt: 2 }}>
                    <InputLabel id="label" sx={{ fontSize: '13px' }}>
                      Tipo de cliente *
                    </InputLabel>
                    <Select
                      name="id_type_client"
                      fullWidth
                      size="small"
                      required
                      disabled={infosClients.id ? true : false}
                      value={infosClients.id_type_client || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {company !== 'higiasaude' && <MenuItem value={1}>Físico</MenuItem>}
                      <MenuItem value={2}>Jurídico</MenuItem>
                    </Select>
                  </Grid>
                  {infoState.controlacaepf === 'Sim' && infosClients.id_type_client === 2 && (
                    <Grid item xs={12} md={2} sx={isMobile ? {} : { mt: 2 }}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Tipo de documento *
                      </InputLabel>
                      <Select
                        name="tpdocument"
                        fullWidth
                        size="small"
                        required
                        disabled={infosClients.id ? true : false}
                        value={infosClients.tpdocument || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'CNPJ'}>Controle por CNPJ</MenuItem>
                        <MenuItem value={'CAEPF'}>Controle por CAEPF</MenuItem>
                      </Select>
                    </Grid>
                  )}
                  <Grid item xs={12} md={2}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { fontSize: '13px' } : { fontSize: '13px', mt: 2 }}>
                      Tipo de contratação *
                    </InputLabel>
                    <Select
                      name="tpcontrat_client"
                      fullWidth
                      size="small"
                      required
                      disabled={
                        (infosClients.statusvenda !== undefined &&
                          infosClients.statusvenda === 'Aberta' &&
                          infoState.id_type_user === 1) ||
                        (infosClients.statusvenda !== undefined &&
                          infosClients.statusvenda !== 'Aberta')
                          ? true
                          : false
                      }
                      value={infosClients.tpcontrat_client || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {infosTypesOfHiring.map((item) => (
                        <MenuItem key={item.id} value={item.tpcontrat}>
                          {item.tpcontrat}
                        </MenuItem>
                      ))}
                      {/* <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                      <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                      <MenuItem value={'3-COLETIVO POR ADESAO'}>3-COLETIVO POR ADESÃO</MenuItem> */}
                    </Select>
                  </Grid>
                  {infoState.id_profile !== 1 && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 4.2 }}>
                      <TextField
                        name="nomevend"
                        fullWidth
                        label="Vendedor(a)"
                        variant="outlined"
                        size="small"
                        required
                        disabled
                        value={infosClients.labelvend || infoState.nome}
                      />
                    </Grid>
                  )}
                  {infoState.id_profile === 1 && infosClients.id && (
                    <>
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 4.2 }}>
                        <TextField
                          name="nomevend"
                          fullWidth
                          label="Corretora"
                          variant="outlined"
                          size="small"
                          required
                          disabled
                          value={infosClients.empresa_vendedor}
                        />
                      </Grid>
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 4.2 }}>
                        <Autocomplete
                          options={infoSelectVend}
                          renderOption={(props, option) => <li {...props}>{option.label}</li>}
                          isOptionEqualToValue={(option, value) =>
                            value ? option.label === value : option.label === ''
                          }
                          onChange={(event, value) => HandleInputChange(value, { vend: true })}
                          value={infosClients.labelvend || ''}
                          defaultValue=""
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Vendedor(a)"
                              name="nomevend"
                              fullWidth
                              size="small"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </Grid>
                    </>
                  )}
                  {infoState.id_type_user === 2 &&
                    infosClients.statusvenda !== 'Negada' &&
                    infosClients.statusvenda !== 'Cancelada pelo proponente' &&
                    infoState.tipooperacao !== 'Odonto' &&
                    infoState.entrevisqualificada === 'Não' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Status da venda *
                        </InputLabel>
                        <Select
                          name="statusvenda"
                          fullWidth
                          size="small"
                          required
                          disabled={
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) ||
                            infosClients.statusvenda === 'Análise'
                              ? true
                              : false
                          }
                          value={infosClients.statusvenda || ''}
                          onChange={(event) =>
                            infosClients.id
                              ? HandleInputStatusSalesChange(event)
                              : HandleInputChange(event)
                          }>
                          <MenuItem value={'Aberta'}>Aberta</MenuItem>
                          {infosClients.id && <MenuItem value={'Análise'}>Análise</MenuItem>}
                          {infosClients.id &&
                            infoState.tipo !== 'Complexo' &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Rejeitada'}>Rejeitada</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando corretora'}>
                                Aguardando corretora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando operadora'}>
                                Aguardando operadora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infoState.tipo === 'Complexo' &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando administradora'}>
                                Aguardando administradora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Negada'}>Negada</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Cancelada pelo proponente'}>
                                Cancelada (Proponente)
                              </MenuItem>
                            )}
                        </Select>
                      </Grid>
                    )}
                  {infoState.id_type_user === 2 &&
                    infosClients.statusvenda !== 'Negada' &&
                    infosClients.statusvenda !== 'Cancelada pelo proponente' &&
                    infoState.tipooperacao === 'Odonto' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Status da venda *
                        </InputLabel>
                        <Select
                          name="statusvenda"
                          fullWidth
                          size="small"
                          required
                          disabled={
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) ||
                            infosClients.statusvenda === 'Análise'
                              ? true
                              : false
                          }
                          value={infosClients.statusvenda || ''}
                          onChange={(event) =>
                            infosClients.id
                              ? HandleInputStatusSalesChange(event)
                              : HandleInputChange(event)
                          }>
                          <MenuItem value={'Aberta'}>Aberta</MenuItem>
                          {infosClients.id && <MenuItem value={'Análise'}>Análise</MenuItem>}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando administradora'}>
                                Aguardando administradora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando operadora'}>
                                Aguardando operadora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                            )}
                        </Select>
                      </Grid>
                    )}
                  {infoState.id_type_user === 1 &&
                    infoState.tipooperacao !== 'Odonto' &&
                    infoState.entrevisqualificada === 'Não' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Status da venda *
                        </InputLabel>
                        <Select
                          name="statusvenda"
                          fullWidth
                          size="small"
                          required
                          disabled={infosClients.statusvenda === 'Aprovada' ? true : false}
                          value={infosClients.statusvenda || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'Aberta'}>Aberta</MenuItem>
                          <MenuItem value={'Análise'}>Análise</MenuItem>
                          {infoState.tipo !== 'Complexo' && (
                            <MenuItem value={'Rejeitada'}>Rejeitada</MenuItem>
                          )}
                          <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                          <MenuItem value={'Aguardando corretora'}>Aguardando corretora</MenuItem>
                          <MenuItem value={'Aguardando operadora'}>Aguardando operadora</MenuItem>
                          {infoState.tipo === 'Complexo' && (
                            <MenuItem value={'Aguardando administradora'}>
                              Aguardando administradora
                            </MenuItem>
                          )}
                          <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                          <MenuItem value={'Negada'}>Negada</MenuItem>
                          <MenuItem value={'Cancelada pelo proponente'}>
                            Cancelada (Proponente)
                          </MenuItem>
                        </Select>
                      </Grid>
                    )}
                  {infoState.id_type_user === 1 &&
                    infoState.tipooperacao !== 'Odonto' &&
                    infoState.entrevisqualificada === 'Sim' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Status da venda *
                        </InputLabel>
                        <Select
                          name="statusvenda"
                          fullWidth
                          size="small"
                          required
                          disabled={infosClients.statusvenda === 'Aprovada' ? true : false}
                          value={infosClients.statusvenda || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          {infoState.id_profile !== 4 && (
                            <MenuItem value={'Aberta'}>Aberta</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && (
                            <MenuItem value={'Análise'}>Análise</MenuItem>
                          )}
                          {infoState.id_profile !== 2 && (
                            <MenuItem value={'Realizar entrevista'}>Realizar entrevista</MenuItem>
                          )}
                          {infoState.id_profile !== 2 && (
                            <MenuItem value={'Analisar entrevista'}>Analisar entrevista</MenuItem>
                          )}
                          {infoState.incluiagravo === 'Sim' &&
                            infoState.id_profile !== 2 &&
                            company !== 'higiasaude' && (
                              <MenuItem value={'Aguardando CPT(s)'}>Aguardando CPT(s)</MenuItem>
                            )}
                          {infoState.incluiagravo === 'Sim' &&
                            infoState.id_profile === 1 &&
                            company === 'higiasaude' && (
                              <MenuItem value={'Aguardando CPT(s)'}>Aguardando CPT(s)</MenuItem>
                            )}
                          {infoState.id_profile === 4 &&
                            infoState.incluiagravo === 'Sim' &&
                            infoState.id_profile !== 2 && (
                              <MenuItem value={'Aguardando operadora'}>
                                Aguardando operadora
                              </MenuItem>
                            )}
                          {infoState.id_profile !== 4 && (
                            <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && infoState.id_profile !== 2 && (
                            <MenuItem value={'Aguardando corretora'}>Aguardando corretora</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && infoState.id_profile !== 2 && (
                            <MenuItem value={'Aguardando operadora'}>Aguardando operadora</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && infoState.id_profile !== 2 && (
                            <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && infoState.id_profile !== 2 && (
                            <MenuItem value={'Negada'}>Negada</MenuItem>
                          )}
                          {infoState.id_profile !== 4 && infoState.id_profile !== 2 && (
                            <MenuItem value={'Cancelada pelo proponente'}>
                              Cancelada (Proponente)
                            </MenuItem>
                          )}
                        </Select>
                      </Grid>
                    )}
                  {infoState.id_type_user === 1 && infoState.tipooperacao === 'Odonto' && (
                    <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Status da venda *
                      </InputLabel>
                      <Select
                        name="statusvenda"
                        fullWidth
                        size="small"
                        required
                        disabled={infosClients.statusvenda === 'Aprovada' ? true : false}
                        value={infosClients.statusvenda || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'Aberta'}>Aberta</MenuItem>
                        <MenuItem value={'Análise'}>Análise</MenuItem>
                        <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                        <MenuItem value={'Aguardando administradora'}>
                          Aguardando administradora
                        </MenuItem>
                        <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                        <MenuItem value={'Negada'}>Negada</MenuItem>
                        <MenuItem value={'Cancelada pelo proponente'}>
                          Cancelada (Proponente)
                        </MenuItem>
                      </Select>
                    </Grid>
                  )}
                  {infoState.id_type_user === 2 &&
                    infosClients.statusvenda !== 'Negada' &&
                    infosClients.statusvenda !== 'Cancelada pelo proponente' &&
                    infoState.tipooperacao !== 'Odonto' &&
                    infoState.entrevisqualificada === 'Sim' && (
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: -0.5 } : { mt: 1.7 }}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Status da venda *
                        </InputLabel>
                        <Select
                          name="statusvenda"
                          fullWidth
                          size="small"
                          required
                          disabled={
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) ||
                            infosClients.statusvenda === 'Análise'
                              ? true
                              : false
                          }
                          value={infosClients.statusvenda || ''}
                          onChange={(event) =>
                            infosClients.id
                              ? HandleInputStatusSalesChange(event)
                              : HandleInputChange(event)
                          }>
                          <MenuItem value={'Aberta'}>Aberta</MenuItem>
                          {infosClients.id && <MenuItem value={'Análise'}>Análise</MenuItem>}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Realizar entrevista'}>Realizar entrevista</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Analisar entrevista'}>Analisar entrevista</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando CPT(s)'}>Aguardando CPT(s)</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                            )}

                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando corretora'}>
                                Aguardando corretora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando operadora'}>
                                Aguardando operadora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infoState.tipo === 'Complexo' &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aguardando administradora'}>
                                Aguardando administradora
                              </MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Negada'}>Negada</MenuItem>
                            )}
                          {infosClients.id &&
                            infosDisabledStatusVenda.includes(infosClients.statusvenda) && (
                              <MenuItem value={'Cancelada pelo proponente'}>
                                Cancelada (Proponente)
                              </MenuItem>
                            )}
                        </Select>
                      </Grid>
                    )}
                  {infoState.controlacaepf === 'Não' && (
                    <Grid item xs={12} md={2} sx={isMobile ? {} : { mt: 3.8 }}>
                      <TextField
                        name="dtvigencia"
                        label="Data da vigência"
                        fullWidth
                        type="date"
                        required
                        variant="outlined"
                        size="small"
                        value={infosClients.dtvigencia || ''}
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={() => validDtvigencia()}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
                {infosClients.id_type_client === 1 && (
                  <>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12} md={2}>
                        <InputMask
                          mask="999.999.999-99"
                          value={infosClients.cpf_cnpj || ''}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => validCPF(event)}>
                          {() => (
                            <TextField
                              name="cpf_cnpj"
                              fullWidth
                              label="CPF"
                              required
                              variant="outlined"
                              size="small"
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          name="nome"
                          fullWidth
                          label="Nome completo"
                          variant="outlined"
                          size="small"
                          required
                          value={infosClients.nome || ''}
                          inputProps={{ maxLength: 100 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          name="nomesocial"
                          fullWidth
                          label="Nome social"
                          variant="outlined"
                          size="small"
                          value={infosClients.nomesocial || ''}
                          inputProps={{ maxLength: 100 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          name="dtnascimento"
                          label="Data de nascimento"
                          fullWidth
                          type="date"
                          required
                          variant="outlined"
                          size="small"
                          value={infosClients.dtnascimento || ''}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={() => validDtnascimento()}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          name="rg"
                          label="RG"
                          fullWidth
                          placeholder="Ex: 99.999.999-9"
                          // required
                          variant="outlined"
                          size="small"
                          value={infosClients.rg || ''}
                          inputProps={{ maxLength: 20 }}
                          onChange={(event) => HandleInputChange(event)}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12} md={3}>
                        <Autocomplete
                          options={infosOrgaEmissor}
                          renderOption={(props, option) => <li {...props}>{option.label}</li>}
                          isOptionEqualToValue={(option, value) =>
                            value
                              ? option.label === value
                              : option.label === '' || option.label === ' - '
                          }
                          onChange={(event, value) =>
                            HandleInputChange(value, { autocomplete: true })
                          }
                          value={infosClients.label || ''}
                          defaultValue=""
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Orgão emissor"
                              name="orgao_emissor"
                              fullWidth
                              size="small"
                              variant="outlined"
                              // required
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <InputMask
                          mask="(99)99999-9999"
                          value={infosClients.celular || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          {() => (
                            <TextField
                              name="celular"
                              fullWidth
                              label="Celular"
                              variant="outlined"
                              size="small"
                              required
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <InputMask
                          mask="(99)9999-9999"
                          onChange={(event) => HandleInputChange(event)}
                          value={infosClients.telefone || ''}>
                          {() => (
                            <TextField
                              name="telefone"
                              fullWidth
                              label="Telefone residencial"
                              variant="outlined"
                              size="small"
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          name="email"
                          fullWidth
                          label="Email"
                          type="email"
                          required
                          size="small"
                          variant="outlined"
                          value={infosClients.email || ''}
                          inputProps={{ maxLength: 50, style: { textTransform: 'lowerCase' } }}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => HandleUpdateEmail(event)}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      {infosClients.id_type_client === 1 && (
                        <>
                          <Grid item xs={12} md={3}>
                            <TextField
                              name="nomedamae"
                              fullWidth
                              label="Nome da mãe"
                              size="small"
                              variant="outlined"
                              required
                              inputProps={{ maxLength: 100 }}
                              value={infosClients.nomedamae || ''}
                              onChange={(event) => HandleInputChange(event)}
                            />
                          </Grid>
                        </>
                      )}
                      {infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO' && (
                        <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                          <TextField
                            name="profissao"
                            fullWidth
                            required
                            label="Profissão"
                            size="small"
                            variant="outlined"
                            inputProps={{ maxLength: 100 }}
                            value={infosClients.profissao || ''}
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                        <TextField
                          name="cns"
                          fullWidth
                          required
                          label="Cartão nacional do SUS"
                          size="small"
                          variant="outlined"
                          value={infosClients.cns || ''}
                          inputProps={{ maxLength: 15 }}
                          onChange={(event) => HandleInputChange(event)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={buscarCNS}
                                  edge="end"
                                  size="small"
                                  title="Buscar CNS automaticamente">
                                  <Iconify icon="eva:search-outline" />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                        <TextField
                          name="decnascidovivo"
                          fullWidth
                          label="Declaração de nascido vivo"
                          size="small"
                          variant="outlined"
                          type="number"
                          inputProps={{ maxLength: 12, autoComplete: 'off' }}
                          value={infosClients.decnascidovivo || ''}
                          onChange={(event) => HandleInputChange(event)}
                          InputLabelProps={{
                            autoComplete: 'off'
                          }}
                        />
                      </Grid>

                      {infoState.id_type_user === 1 && (
                        <Grid item xs={8} md={2} sx={isMobile ? { mt: 0 } : { mt: 0 }}>
                          <TextField
                            name="password"
                            fullWidth
                            label="Senha"
                            type={showPassword ? 'text' : 'password'}
                            onChange={(event) => HandleInputChange(event)}
                            value={infosClients.senha || ''}
                            inputProps={{ maxLength: 8 }}
                            required
                            size="small"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end">
                                    <Iconify
                                      icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        </Grid>
                      )}
                      {isMobile && infoState.id_type_user === 1 && (
                        <Grid item xs={4} md={1}>
                          <Stack direction="row" alignItems="center" justifyContent="end">
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<LockResetIcon />}
                              onClick={GeneratePassword}>
                              Senha
                            </Button>
                          </Stack>
                        </Grid>
                      )}
                      {!isMobile && infoState.id_type_user === 1 && (
                        <Grid item xs={12} md={1}>
                          <Button
                            sx={{ mt: 0 }}
                            variant="contained"
                            color="primary"
                            startIcon={<LockResetIcon />}
                            onClick={GeneratePassword}>
                            Senha
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0 }}>
                      <Grid item xs={12} md={infosClients.id ? 2 : 3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Titular/responsável jurídico? *
                        </InputLabel>
                        <Select
                          name="titbenef"
                          fullWidth
                          size="small"
                          disabled={
                            (infosDeps.length > 0 ? true : false) ||
                            (infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO' &&
                              company !== 'gocare' &&
                              company !== 'medsaude')
                          }
                          required
                          value={infosClients.titbenef || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'S'}>Sim</MenuItem>
                          <MenuItem value={'N'}>Não</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} md={infosClients.id ? 2 : 3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Contato via email/sms? *
                        </InputLabel>
                        <Select
                          name="aceitesmsemail"
                          fullWidth
                          size="small"
                          disabled={infoState.id_type_user === 2 ? true : false}
                          required
                          value={infosClients.aceitesmsemail || 'S'}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'S'}>Sim</MenuItem>
                          <MenuItem value={'N'}>Não</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Sexo *
                        </InputLabel>
                        <Select
                          name="sexo"
                          fullWidth
                          size="small"
                          required
                          value={infosClients.sexo || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'Masculino'}>Masculino</MenuItem>
                          <MenuItem value={'Feminino'}>Feminino</MenuItem>
                          <MenuItem value={'Outros'}>Outros</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Estado civil *
                        </InputLabel>
                        <Select
                          name="estadocivil"
                          fullWidth
                          size="small"
                          required
                          value={infosClients.estadocivil || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'Solteiro(a)'}>Solteiro(a)</MenuItem>
                          <MenuItem value={'Casado(a)'}>Casado(a)</MenuItem>
                          <MenuItem value={'Divorciado(a)'}>Divorciado(a)</MenuItem>
                          <MenuItem value={'Viuvo(a)'}>Viuvo(a)</MenuItem>
                          {infoState.tipo !== 'Complexo' && (
                            <MenuItem value={'Companheiro(a)'}>Companheiro(a)</MenuItem>
                          )}
                        </Select>
                      </Grid>
                      {infosClients.id && (
                        <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                          <TextField
                            name="valueTotal"
                            fullWidth
                            label="Valor total "
                            size="small"
                            variant="outlined"
                            inputProps={{ maxLength: 15 }}
                            value={`R$ ${
                              infosClients.valueTotal != null &&
                              infosClients.valueTotal !== '' &&
                              !Number.isNaN(Number(infosClients.valueTotal))
                                ? infosClients.valueTotal
                                : '0.00'
                            }`}
                            sx={isMobile ? { mt: 1 } : { ml: 0.1 }}
                            disabled
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0 }}>
                      {infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO' && (
                        <Grid item xs={12} md={2}>
                          <InputLabel id="label" sx={{ fontSize: '13px' }}>
                            Associação para vinculação *
                          </InputLabel>
                          <Autocomplete
                            options={infosAssociations}
                            renderOption={(props, option) => <li {...props}>{option.label}</li>}
                            isOptionEqualToValue={(option, value) =>
                              value ? option.label === value : option.label === ''
                            }
                            onChange={(event, value) =>
                              HandleInputChange(value, { association: true })
                            }
                            value={infosClients.labelassociation || ''}
                            defaultValue=""
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="id_association"
                                fullWidth
                                size="small"
                                variant="outlined"
                                required
                              />
                            )}
                          />
                        </Grid>
                      )}
                      {infoState.tipooperacao !== 'Odonto' && (
                        <>
                          <Grid
                            item
                            xs={12}
                            md={
                              infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO' ? 2.5 : 3
                            }>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Produto/Plano *
                            </InputLabel>
                            <Autocomplete
                              options={infosPlans}
                              renderOption={(props, option) => <li {...props}>{option.label}</li>}
                              isOptionEqualToValue={(option, value) =>
                                value ? option.label === value : option.label === ''
                              }
                              onChange={(event, value) => HandleInputChange(value, { plan: true })}
                              value={infosClients.labelplans || ''}
                              defaultValue=""
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="codplano"
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  required
                                />
                              )}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={
                              infosClients.tpcontrat_client === '3-COLETIVO POR ADESAO' ? 2.5 : 3
                            }>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Tabela *
                            </InputLabel>
                            <Autocomplete
                              options={infosTablesTemp}
                              renderOption={(props, option) => <li {...props}>{option.label}</li>}
                              isOptionEqualToValue={(option, value) =>
                                value ? option.label === value : option.label === ''
                              }
                              onChange={(event, value) => HandleInputChange(value, { table: true })}
                              value={infosClients.labeltables || ''}
                              defaultValue=""
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="codtab"
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  required
                                />
                              )}
                            />
                          </Grid>
                        </>
                      )}
                      {infoState.tipooperacao === 'Odonto' && (
                        <>
                          <Grid item xs={12} md={3}>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Produto/Plano *
                            </InputLabel>
                            <Autocomplete
                              options={infosPlans}
                              renderOption={(props, option) => <li {...props}>{option.label}</li>}
                              isOptionEqualToValue={(option, value) =>
                                value ? option.label === value : option.label === ''
                              }
                              onChange={(event, value) => HandleInputChange(value, { plan: true })}
                              value={infosClients.labelplans || ''}
                              defaultValue=""
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="codplano"
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  required
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Tabela *
                            </InputLabel>
                            <Autocomplete
                              options={infosTablesTemp}
                              renderOption={(props, option) => <li {...props}>{option.label}</li>}
                              isOptionEqualToValue={(option, value) =>
                                value ? option.label === value : option.label === ''
                              }
                              onChange={(event, value) => HandleInputChange(value, { table: true })}
                              value={infosClients.labeltables || ''}
                              defaultValue=""
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="codtab"
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  required
                                />
                              )}
                            />
                          </Grid>
                        </>
                      )}
                      {infosClients.titbenef == 'S' && infoState.tipooperacao !== 'Odonto' && (
                        <>
                          <Grid item xs={12} md={2}>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Carência do beneficiário *
                            </InputLabel>
                            <Autocomplete
                              options={infosWaitingPeriod}
                              renderOption={(props, option) => <li {...props}>{option.label}</li>}
                              isOptionEqualToValue={(option, value) =>
                                value ? option.label === value : option.label === ''
                              }
                              onChange={(event, value) =>
                                HandleInputChange(value, { waitingPeriod: true })
                              }
                              value={infosClients.labelcarencia || ''}
                              defaultValue=""
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="codcarencia"
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  required
                                />
                              )}
                            />
                          </Grid>
                        </>
                      )}
                      {infosClients.titbenef == 'S' && (
                        <>
                          <Grid item xs={8} md={2}>
                            <InputLabel id="label" sx={{ fontSize: '13px' }}>
                              Valor *
                            </InputLabel>
                            <TextField
                              name="valclient"
                              fullWidth
                              variant="outlined"
                              size="small"
                              required
                              value={`R$ ${salesValue}`}
                              InputProps={{
                                readOnly: true
                              }}
                            />
                          </Grid>
                          {isMobile && (
                            <Grid item xs={4}>
                              <Stack direction="row" alignItems="center" justifyContent="end">
                                <Button
                                  sx={!isMobile ? { mt: 3 } : { mt: 2.5 }}
                                  variant="contained"
                                  color="success"
                                  onClick={CalculeValuesClient}
                                  startIcon={<Iconify icon="ant-design:calculator-outlined" />}>
                                  Calcular
                                </Button>
                              </Stack>
                            </Grid>
                          )}
                          {!isMobile && (
                            <Grid item xs={3} md={1}>
                              <Button
                                sx={!isMobile ? { mt: 2.5 } : { mt: 1 }}
                                variant="contained"
                                color="success"
                                onClick={CalculeValuesClient}
                                startIcon={<Iconify icon="ant-design:calculator-outlined" />}>
                                Calcular
                              </Button>
                            </Grid>
                          )}
                        </>
                      )}
                    </Grid>
                  </>
                )}
                {infosClients.id_type_client === 2 && (
                  <>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      {infoState.controlacaepf === 'Sim' &&
                        infosClients.id_type_client === 2 &&
                        (infosClients.tpdocument === 'CNPJ' || !infosClients.tpdocument) && (
                          <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                            <InputMask
                              mask="**.***.***/****-99"
                              formatChars={{
                                '*': '[A-Z0-9]',
                                9: '[0-9]'
                              }}
                              value={infosClients.cpf_cnpj || ''}
                              onChange={(event) => HandleInputChange(event)}
                              onBlur={(event) => validCNPJ(event)}>
                              {() => (
                                <TextField
                                  name="cpf_cnpj"
                                  fullWidth
                                  label="CNPJ"
                                  required
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                            </InputMask>
                          </Grid>
                        )}
                      {infoState.controlacaepf === 'Sim' &&
                        infosClients.id_type_client === 2 &&
                        infosClients.tpdocument === 'CAEPF' && (
                          <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                            <TextField
                              name="cpf_cnpj"
                              fullWidth
                              label="CAEPF"
                              variant="outlined"
                              size="small"
                              required
                              value={infosClients.cpf_cnpj || ''}
                              inputProps={{ maxLength: 100 }}
                              onChange={(event) => HandleInputChange(event)}
                            />
                          </Grid>
                        )}
                      {infoState.controlacaepf === 'Não' && infosClients.id_type_client === 2 && (
                        <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                          <InputMask
                            mask="**.***.***/****-99"
                            formatChars={{
                              '*': '[A-Z0-9]',
                              9: '[0-9]'
                            }}
                            value={infosClients.cpf_cnpj || ''}
                            onChange={(event) => HandleInputChange(event)}
                            onBlur={(event) => validCNPJ(event)}>
                            {() => (
                              <TextField
                                name="cpf_cnpj"
                                fullWidth
                                label="CNPJ"
                                required
                                variant="outlined"
                                size="small"
                              />
                            )}
                          </InputMask>
                        </Grid>
                      )}
                      <Grid item xs={12} md={3}>
                        <TextField
                          name="nome"
                          fullWidth
                          label="Razão social"
                          variant="outlined"
                          size="small"
                          required
                          value={infosClients.nome || ''}
                          inputProps={{ maxLength: 48 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                        <TextField
                          name="nomefantasia"
                          fullWidth
                          label="Nome fantasia"
                          variant="outlined"
                          size="small"
                          value={infosClients.nomefantasia || ''}
                          inputProps={{ maxLength: 48 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={infoState.id_type_user === 1 ? 2 : 3}>
                        <TextField
                          name="email"
                          fullWidth
                          label="Email"
                          type="email"
                          required
                          size="small"
                          variant="outlined"
                          value={infosClients.email || ''}
                          inputProps={{ maxLength: 50, style: { textTransform: 'lowerCase' } }}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => HandleUpdateEmail(event)}
                        />
                      </Grid>
                      {infoState.id_type_user === 1 && (
                        <Grid item xs={8} md={2} sx={isMobile ? { mt: 0 } : { mt: 0 }}>
                          <TextField
                            name="password"
                            fullWidth
                            label="Senha"
                            type={showPassword ? 'text' : 'password'}
                            onChange={(event) => HandleInputChange(event)}
                            value={infosClients.senha || ''}
                            inputProps={{ maxLength: 8 }}
                            required
                            size="small"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end">
                                    <Iconify
                                      icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        </Grid>
                      )}
                      {isMobile && infoState.id_type_user === 1 && (
                        <Grid item xs={4} md={1}>
                          <Stack direction="row" alignItems="center" justifyContent="end">
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<LockResetIcon />}
                              onClick={GeneratePassword}>
                              Senha
                            </Button>
                          </Stack>
                        </Grid>
                      )}
                      {!isMobile && infoState.id_type_user === 1 && (
                        <Grid item xs={12} md={1}>
                          <Button
                            sx={{ mt: 0 }}
                            variant="contained"
                            color="primary"
                            startIcon={<LockResetIcon />}
                            onClick={GeneratePassword}>
                            Senha
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12} md={2}>
                        <InputMask
                          mask="(99)99999-9999"
                          value={infosClients.celular || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          {() => (
                            <TextField
                              name="celular"
                              fullWidth
                              label="Celular"
                              variant="outlined"
                              size="small"
                              required
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <InputMask
                          mask="(99)9999-9999"
                          onChange={(event) => HandleInputChange(event)}
                          value={infosClients.telefone || ''}>
                          {() => (
                            <TextField
                              name="telefone"
                              fullWidth
                              label="Telefone comercial"
                              variant="outlined"
                              size="small"
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          name="nome_resp"
                          fullWidth
                          label="Nome responsável"
                          required
                          size="small"
                          variant="outlined"
                          value={infosClients.nome_resp || ''}
                          inputProps={{ maxLength: 100 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <InputMask
                          mask="999.999.999-99"
                          value={infosClients.cpf_cnpj_resp || ''}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => validCPF(event)}>
                          {() => (
                            <TextField
                              name="cpf_cnpj_resp"
                              fullWidth
                              label="CPF responsável"
                              required
                              variant="outlined"
                              size="small"
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 0 }}>
                        <TextField
                          name="nome_contato"
                          label="Nome do contato"
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={infosClients.nome_contato || ''}
                          inputProps={{ maxLength: 20 }}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 0 }}>
                        <TextField
                          name="email_contato"
                          label="Email contato direto"
                          fullWidth
                          variant="outlined"
                          size="small"
                          type="email"
                          value={infosClients.email_contato || ''}
                          inputProps={{ maxLength: 50 }}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => HandleUpdateEmail(event)}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.1 }}>
                      <Grid item xs={12} md={2}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Responsável incluído no plano? *
                        </InputLabel>
                        <Select
                          name="included_resp"
                          fullWidth
                          size="small"
                          required
                          disabled={infosDeps.length > 0 ? true : false}
                          value={infosClients.included_resp || ''}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'S'}>Sim</MenuItem>
                          <MenuItem value={'N'}>Não</MenuItem>
                        </Select>
                      </Grid>
                      {infoState.liberacarencia === 'Sim' && (
                        <Grid item xs={12} md={2}>
                          <InputLabel id="label" sx={{ fontSize: '13px' }}>
                            Possuirá carência? *
                          </InputLabel>
                          <Select
                            name="included_shortage"
                            fullWidth
                            size="small"
                            required
                            value={infosClients.included_shortage || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'S'}>Sim</MenuItem>
                            <MenuItem value={'N'}>Não</MenuItem>
                          </Select>
                        </Grid>
                      )}
                      <Grid item xs={12} md={2}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Contato via email/sms? *
                        </InputLabel>
                        <Select
                          name="aceitesmsemail"
                          fullWidth
                          size="small"
                          disabled={infoState.id_type_user === 2 ? true : false}
                          required
                          value={infosClients.aceitesmsemail || 'S'}
                          onChange={(event) => HandleInputChange(event)}>
                          <MenuItem value={'S'}>Sim</MenuItem>
                          <MenuItem value={'N'}>Não</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} md={infoState.liberacarencia === 'Sim' ? 2 : 3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Produto/Plano *
                        </InputLabel>
                        <Autocomplete
                          options={infosPlans}
                          renderOption={(props, option) => <li {...props}>{option.label}</li>}
                          isOptionEqualToValue={(option, value) =>
                            value ? option.label === value : option.label === ''
                          }
                          onChange={(event, value) => HandleInputChange(value, { plan: true })}
                          value={infosClients.labelplans || ''}
                          defaultValue=""
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="codplano"
                              fullWidth
                              size="small"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={infoState.liberacarencia === 'Sim' ? 2 : 3}>
                        <InputLabel id="label" sx={{ fontSize: '13px' }}>
                          Tabela *
                        </InputLabel>
                        <Autocomplete
                          options={infosTablesTemp}
                          renderOption={(props, option) => <li {...props}>{option.label}</li>}
                          isOptionEqualToValue={(option, value) =>
                            value ? option.label === value : option.label === ''
                          }
                          onChange={(event, value) => HandleInputChange(value, { table: true })}
                          value={infosClients.labeltables || ''}
                          defaultValue=""
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="codtab"
                              fullWidth
                              size="small"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </Grid>
                      {infosClients.id && (
                        <Grid item xs={12} md={2}>
                          <TextField
                            name="valueTotal"
                            fullWidth
                            label="Valor total "
                            size="small"
                            variant="outlined"
                            inputProps={{ maxLength: 15 }}
                            value={`R$ ${
                              infosClients.valueTotal != null &&
                              infosClients.valueTotal !== '' &&
                              !Number.isNaN(Number(infosClients.valueTotal))
                                ? infosClients.valueTotal
                                : '0.00'
                            }`}
                            sx={isMobile ? { mt: 1 } : { ml: 0.1, mt: 2.2 }}
                            disabled
                          />
                        </Grid>
                      )}
                    </Grid>
                  </>
                )}
                {infosClients.statusvenda !== 'Negada' &&
                  infosClients.statusvenda !== 'Cancelada pelo proponente' && (
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} md={12}>
                        <InputLabel id="label" sx={{ fontSize: '13px', ml: 0.3 }}>
                          Observações sobre a venda:
                        </InputLabel>
                        <TextareaAutosize
                          name="obs"
                          label="Observações sobre a venda"
                          // disabled={infoState.id_type_user === 1 ? false : true}
                          size="small"
                          variant="outlined"
                          minRows={3}
                          value={infosClients.obs || ''}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                    </Grid>
                  )}
                {infosClients.statusvenda !== 'Negada' &&
                  infosClients.statusvenda !== 'Cancelada pelo proponente' &&
                  infoState.id_type_user === 1 &&
                  infoState.entrevisqualificada === 'Sim' && (
                    <Grid container spacing={2} sx={{ mt: 0.1 }}>
                      <Grid item xs={12} md={12}>
                        <InputLabel id="label" sx={{ fontSize: '13px', ml: 0.3 }}>
                          Observações/declínios entrevista:
                        </InputLabel>
                        <TextareaAutosize
                          name="analisemedicadeclinio"
                          label=" Observações/declínios entrevista:"
                          // disabled={infoState.id_type_user === 1 ? false : true}
                          size="small"
                          variant="outlined"
                          minRows={3}
                          value={infosClients.analisemedicadeclinio || ''}
                          onChange={(event) => HandleInputChange(event)}
                          onBlur={(event) => HandleUpdateDeclinio(event)}
                        />
                      </Grid>
                    </Grid>
                  )}
                {(infosClients.statusvenda === 'Negada' ||
                  infosClients.statusvenda === 'Cancelada pelo proponente') &&
                  infoState.id_type_user === 1 && (
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} md={12}>
                        <InputLabel id="label" sx={{ fontSize: '13px', ml: 0.3 }}>
                          {`Motivo ${
                            infosClients.statusvenda === 'Cancelada pelo proponente'
                              ? 'do cancelamento'
                              : 'da negativa'
                          } *`}
                        </InputLabel>
                        <TextareaAutosize
                          name="motivo_negativa"
                          required
                          size="small"
                          variant="outlined"
                          minRows={3}
                          value={infosClients.motivo_negativa || ''}
                          onChange={(event) => HandleInputChange(event)}
                        />
                      </Grid>
                    </Grid>
                  )}
              </Box>
              {infosClients.id && (
                <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200' }}>
                  <TabContext value={values}>
                    <Box sx={{ mt: 1, p: 2 }}>
                      <TabList
                        onChange={handleTabsChange}
                        aria-label="ClientsTabs"
                        variant="scrollable"
                        scrollButtons="auto">
                        <Tab label="Endereços" value="1" />
                        <Tab
                          label={
                            infosClients.id_type_client === 1 && company !== 'gocare'
                              ? 'Dependentes'
                              : 'Beneficiários'
                          }
                          value="2"
                        />
                        <Tab label="Documentos/Uploads" value="3" />

                        {infosClients.statusvenda === 'Aguardando corretora' && (
                          <Tab label="Assinaturas" value="4" />
                        )}
                        {(infosClients.statusvenda === 'Aguardando operadora' ||
                          infosClients.statusvenda === 'Aprovada' ||
                          infosClients.statusvenda === 'Aguardando administradora') && (
                          <Tab label="Assinaturas" value="4" />
                        )}
                        {infosClients.statusvenda === 'Aprovada' && (
                          <Tab
                            sx={{ textTransform: 'none' }}
                            label="Documentos assinados"
                            value="6"
                          />
                        )}
                        {(infosClients.statusvenda === 'Realizar entrevista' ||
                          infosClients.statusvenda === 'Analisar entrevista' ||
                          infosClients.statusvenda === 'Aguardando CPT(s)' ||
                          infosClients.statusvenda === 'Aguardando cliente') &&
                          infoState.entrevisqualificada === 'Sim' && (
                            <Tab label="Entrevista" value="5" />
                          )}
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item>
                              <CustomInfosForm>Adicionar e/ou remover endereços</CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        {!isMobile && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1 }}>
                            <Button
                              variant="contained"
                              onClick={AddAddressModal}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Novo
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={getAddress}
                              sx={{ ml: 1 }}
                              startIcon={<Iconify icon="eva:refresh-outline" />}>
                              Atualizar
                            </Button>
                          </Stack>
                        )}
                        {isMobile && (
                          <Grid item xs={12} sx={{ mb: 3 }}>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                              <Button
                                variant="contained"
                                onClick={AddAddressModal}
                                startIcon={<Iconify icon="eva:plus-fill" />}>
                                Novo
                              </Button>
                            </Stack>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosAddress}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não foram encontrados endereços'}>
                        <Column dataField="rua" />
                        <Column dataField="numero" caption="Número" width={100} />
                        <Column dataField="bairro" />
                        <Column dataField="cidade" />
                        <Column dataField="estado" width={100} />
                        <Column dataField="cep" width={100} />
                        <Column dataField="desctype" caption="Tipo endereço" width={150} />
                        <Column
                          dataField="Ações"
                          width={100}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtonsAddress data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={10} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="2">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item xs={12}>
                              {infosClients.id_type_client === 1 && (
                                <CustomInfosForm>
                                  Adicionar e/ou remover dependentes
                                </CustomInfosForm>
                              )}
                              {infosClients.id_type_client === 2 && (
                                <CustomInfosForm>
                                  Adicionar e/ou remover beneficiários
                                </CustomInfosForm>
                              )}
                            </Grid>
                          </Grid>
                        )}
                        {!isMobile && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1.5 }}>
                            <Button
                              variant="contained"
                              onClick={AddClientsDependentsModal}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Novo
                            </Button>
                            {company === 'higiasaude' && (
                              <Button
                                variant="contained"
                                sx={{ ml: 1 }}
                                onClick={() => setOpenModalImportLayout(true)}
                                startIcon={<Iconify icon="eva:people-outline" />}>
                                <Typography noWrap sx={{ fontWeight: 'bold' }}>
                                  Importar layout
                                </Typography>
                              </Button>
                            )}
                            {!isMobile && (
                              <Button
                                variant="outlined"
                                onClick={getDependents}
                                sx={{ ml: 1 }}
                                startIcon={<Iconify icon="eva:refresh-outline" />}>
                                Atualizar
                              </Button>
                            )}
                          </Stack>
                        )}
                        {isMobile && (
                          <Grid item xs={12} sx={{ mb: 3 }}>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                              <Button
                                variant="contained"
                                onClick={AddClientsDependentsModal}
                                startIcon={<Iconify icon="eva:plus-fill" />}>
                                Novo
                              </Button>
                            </Stack>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosDeps}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não foram encontrados beneficiários'}>
                        <Column dataField="id" caption="Id" />
                        <Column dataField="nome" />
                        <Column dataField="email" />
                        <Column dataField="cpf_cnpj" caption="Cpf" />
                        <Column dataField="tpbenef" caption="Tipo de beneficiário" />
                        <Column dataField="valclient" caption="Valor R$" />
                        {infosClients.id_type_client === 2 && (
                          <Column
                            dataField="id_tit"
                            caption="Id. titular"
                            cellRender={(data) => <RenderidTit data={data} />}
                          />
                        )}
                        <Column
                          dataField="datacadastro"
                          caption="Data de cadastro"
                          cellRender={(data) => <FormatDate data={data} />}
                        />
                        <Column
                          dataField="Ações"
                          width={100}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtons data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={10} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="3">
                      <Stack direction="row" alignItems="center" justifyContent="start">
                        {!isMobile && (
                          <Grid container>
                            <Grid item xs={12}>
                              <CustomInfosForm>
                                Adicionar, visualizar e/ou remover documentos
                              </CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ mb: 1 }}>
                          <>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => setOpenModalDocumentUpload(true)}
                              sx={{ mr: 1, minWidth: 120 }}
                              startIcon={<Iconify icon="eva:cloud-upload-outline" />}>
                              Upload
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={downloadFilesUploads}
                              sx={{ mr: 1, minWidth: 120 }}
                              disabled={rowsSelected.length ? false : true}
                              startIcon={<Iconify icon="eva:cloud-download-outline" />}>
                              Download
                            </Button>
                            {!isMobile && (
                              <Button
                                variant="outlined"
                                onClick={getFilesUploads}
                                sx={{ minWidth: 120 }}
                                startIcon={<Iconify icon="eva:refresh-outline" />}>
                                Atualizar
                              </Button>
                            )}
                          </>
                        </Stack>
                      </Stack>
                      <DataGrid
                        dataSource={infosUploads}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={selectedRows}
                        noDataText={'Não foram encontrados uploads'}>
                        <Selection mode="multiple" />
                        {/* <Column dataField="id" caption="Id" /> */}
                        <Column dataField="filename" caption="Nome do documento" />
                        <Column
                          dataField="nome_beneficiario"
                          caption="Nome/Razão social"
                          cellRender={(data) => data.value || '-'}
                        />
                        <Column
                          dataField="tpdocument"
                          caption="Tipo de documento"
                          cellRender={(data) => {
                            const typeMap = {
                              rg_cnh: 'RG/CNH',
                              comprovante_residencia: 'Comprovante de Residência',
                              cartao_saude: 'Cartão Nacional de Saúde',
                              ficha_associativa: 'Ficha Associativa',
                              documentos_diversos: 'Documentos Diversos'
                            };
                            return typeMap[data.value] || data.value || '-';
                          }}
                        />
                        <Column dataField="dtope" caption="Data de operação" />
                        <Column
                          dataField="Ações"
                          width={100}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtonsUploads data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={5} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="4">
                      {isMobile && (
                        <>
                          {imcAlerta.show && infoState.id_type_user === 1 && (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                              {imcAlerta.message}
                            </Alert>
                          )}
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="right"
                            sx={{ mb: 2 }}>
                            <Button
                              variant="contained"
                              onClick={showDeclarationHealthModal}
                              sx={{ mr: 1 }}
                              startIcon={<MonitorHeartIcon />}>
                              Visualizar
                            </Button>
                            {infosClients.statusvenda === 'Aguardando corretora' &&
                              infoState.id_type_user === 2 &&
                              infoState.id_profile === 3 && (
                                <DocumentsForSignature
                                  functionGrid={getInfosContract}
                                  infosClients={infosClients}
                                  getInfosClient={getInfosClient}
                                  formClient={true}
                                />
                              )}
                            {(infosClients.statusvenda === 'Aguardando operadora' ||
                              (infosClients.statusvenda === 'Aguardando administradora' &&
                                infoState.id_type_user === 1 &&
                                infoState.id_profile !== 2)) && (
                              <DocumentsForSignature
                                functionGrid={getInfosContract}
                                infosClients={infosClients}
                                getInfosClient={getInfosClient}
                                formClient={true}
                              />
                            )}
                            {infosClients.statusvenda === 'Aprovada' && (
                              <DownloadDocumentsSigning
                                infosClients={infosClients}
                                tipo={infosClients.tpcontrat_client}
                                key={value}
                                formClient={true}
                              />
                            )}
                          </Stack>
                        </>
                      )}
                      {!isMobile && (
                        <>
                          {imcAlerta.show && infoState.id_type_user === 1 && (
                            <Grid item xs={12} sx={{ mb: 1 }}>
                              <Alert severity="warning">{imcAlerta.message}</Alert>
                            </Grid>
                          )}
                          <Stack direction="row" alignItems="center" justifyContent="start">
                            <Grid container>
                              <Grid item xs={12}>
                                <CustomInfosForm>
                                  Visualizar declarações de saúde e assinar documentos
                                </CustomInfosForm>
                              </Grid>
                            </Grid>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="end"
                              sx={{ mb: 2 }}>
                              <Button
                                variant="contained"
                                onClick={showDeclarationHealthModal}
                                sx={{ mr: 0 }}
                                startIcon={<MonitorHeartIcon />}>
                                Visualizar
                              </Button>
                              {infosClients.statusvenda === 'Aguardando corretora' &&
                                infoState.id_type_user === 2 &&
                                infoState.id_profile === 3 && (
                                  <DocumentsForSignature
                                    functionGrid={getInfosContract}
                                    infosClients={infosClients}
                                    getInfosClient={getInfosClient}
                                    formClient={true}
                                  />
                                )}
                              {(infosClients.statusvenda === 'Aguardando operadora' ||
                                infosClients.statusvenda === 'Aguardando administradora') &&
                                infoState.id_type_user === 1 &&
                                infoState.id_profile !== 2 && (
                                  <DocumentsForSignature
                                    functionGrid={getInfosContract}
                                    infosClients={infosClients}
                                    getInfosClient={getInfosClient}
                                    formClient={true}
                                  />
                                )}
                              {infosClients.statusvenda === 'Aprovada' && (
                                <DownloadDocumentsSigning
                                  infosClients={infosClients}
                                  tipo={infosClients.tpcontrat_client}
                                  key={value}
                                  formClient={true}
                                />
                              )}
                            </Stack>
                          </Stack>
                        </>
                      )}
                      <DataGrid
                        dataSource={infosContract.map((item) => {
                          const key = item.flag
                            ? `titular_${infosClients.id}`
                            : `dependente_${item.id}`;
                          return {
                            ...item,
                            imc: imcCalculado[key] || null
                          };
                        })}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={selectedRow}
                        noDataText={'Não foram encontrados registros'}>
                        <Selection mode="single" />
                        <Column dataField="nome" caption="Nome" />
                        <Column dataField="cpf_cnpj" caption="Cpf" />
                        <Column dataField="tpbenef" caption="Tipo de beneficiário" />
                        <Column dataField="email" caption="Email" />
                        {infoState.imc_declinio && infoState.id_type_user === 1 && (
                          <Column
                            dataField="imc"
                            caption="IMC"
                            dataType="number"
                            format="fixedPoint"
                            precision={2}
                            cellRender={(data) => {
                              if (!data.value || isNaN(data.value)) {
                                return <span>-</span>;
                              }
                              const cor = getCorIMC(data.value);
                              if (!cor) {
                                return <span>-</span>;
                              }
                              return (
                                <Chip
                                  label={data.value.toFixed(2)}
                                  size="small"
                                  variant="contained"
                                  sx={{
                                    backgroundColor: cor,
                                    color: '#FFF',
                                    fontWeight: 'medium'
                                  }}
                                />
                              );
                            }}
                          />
                        )}
                        <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={30} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="5">
                      {isMobile && (
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="right"
                          sx={{ mb: 2 }}>
                          <Button
                            variant="contained"
                            onClick={showDeclarationHealthModal}
                            sx={{ mr: 1 }}
                            startIcon={<MonitorHeartIcon />}>
                            Visualizar
                          </Button>
                          {infoState.id_profile === 4 && (
                            <>
                              <Button
                                variant="contained"
                                color="success"
                                onClick={addDeclarationHealthModal}
                                sx={{ textTransform: 'none' }}
                                startIcon={<Iconify icon="eva:edit-fill" />}>
                                Preencher
                              </Button>
                              <Button
                                onClick={() => {
                                  openModalDeleteDeclarationHealth(true);
                                }}
                                color="error"
                                variant="contained"
                                sx={{ ml: 1 }}
                                startIcon={<Iconify icon="eva:trash-2-outline" />}>
                                Excluir
                              </Button>
                            </>
                          )}
                        </Stack>
                      )}
                      {!isMobile && (
                        <>
                          {imcAlerta.show && (
                            <Grid item xs={12} sx={{ mb: 1 }}>
                              <Alert severity="warning">{imcAlerta.message}</Alert>
                            </Grid>
                          )}
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="end"
                            sx={{ mb: 2 }}>
                            <Button
                              variant="contained"
                              onClick={showDeclarationHealthModal}
                              sx={{ mr: 1 }}
                              startIcon={<MonitorHeartIcon />}>
                              Visualizar
                            </Button>
                            {infoState.id_profile === 4 && infoState.analisemedica === 'Não' && (
                              <>
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={addDeclarationHealthModal}
                                  sx={{ textTransform: 'none' }}
                                  startIcon={<Iconify icon="eva:edit-fill" />}>
                                  Preencher
                                </Button>
                                <Button
                                  onClick={() => {
                                    openModalDeleteDeclarationHealth(true);
                                  }}
                                  color="error"
                                  variant="contained"
                                  sx={{ ml: 1 }}
                                  startIcon={<Iconify icon="eva:trash-2-outline" />}>
                                  Excluir
                                </Button>
                              </>
                            )}
                            {/* {infoState.id_type_user === 1 &&
                              infoState.analisemedica === 'Sim' &&
                              infoState.incluiagravo === 'Sim' &&
                              (infosClients.statusvenda === 'Realizar entrevista' ||
                                infosClients.statusvenda === 'Aguardando CPT(s)' ||
                                infosClients.statusvenda === 'Analisar entrevista') && (
                                <>
                                  <Button
                                    variant="contained"
                                    color="error"
                                    sx={{ textTransform: 'none' }}
                                    startIcon={<Iconify icon="eva:alert-triangle-outline" />}
                                    onClick={(e) => setAgravosMenuAnchor(e.currentTarget)}>
                                    Agravos
                                  </Button>
                                  <Menu
                                    anchorEl={agravosMenuAnchor}
                                    open={Boolean(agravosMenuAnchor)}
                                    onClose={() => setAgravosMenuAnchor(null)}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                                    <MenuItem
                                      onClick={() => {
                                        addEditClaimsModal(
                                          { close: () => setAgravosMenuAnchor(null) },
                                          { edit: false }
                                        );
                                      }}>
                                      <Iconify icon="eva:plus-outline" sx={{ mr: 1 }} />
                                      Incluir agravo(s)
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        addEditClaimsModal(
                                          { close: () => setAgravosMenuAnchor(null) },
                                          { edit: true }
                                        );
                                      }}>
                                      <Iconify icon="eva:edit-outline" sx={{ mr: 1 }} />
                                      Editar agravo(s)
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        setAgravosMenuAnchor(null);
                                        setOpenModalDeleteClaim(true);
                                      }}>
                                      <Iconify icon="eva:trash-outline" sx={{ mr: 1 }} />
                                      Excluir agravo(s)
                                    </MenuItem>
                                  </Menu>
                                </>
                              )} */}
                            {infoState.id_type_user === 1 &&
                              infoState.id_profile !== 2 &&
                              infoState.analisemedica === 'Sim' &&
                              infoState.incluiagravo === 'Sim' &&
                              (infosClients.statusvenda === 'Realizar entrevista' ||
                                infosClients.statusvenda === 'Aguardando CPT(s)' ||
                                infosClients.statusvenda === 'Analisar entrevista' ||
                                infosClients.statusvenda === 'Aguardando cliente') && (
                                <PopupState variant="popover" popupId="agravos-popup-menu">
                                  {(popupState) => (
                                    <React.Fragment>
                                      <Button
                                        variant="contained"
                                        color="error"
                                        // onClick={addEditClaimsModal}
                                        sx={{ textTransform: 'none' }}
                                        startIcon={<Iconify icon="eva:alert-triangle-outline" />}
                                        {...bindTrigger(popupState)}>
                                        Agravos
                                      </Button>
                                      <Menu {...bindMenu(popupState)}>
                                        <MenuItem
                                          onClick={() => {
                                            addEditClaimsModal(popupState, { edit: false });
                                          }}>
                                          <Iconify icon="eva:plus-outline" sx={{ mr: 1 }} />
                                          Incluir agravo(s)
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => {
                                            addEditClaimsModal(popupState, { edit: true });
                                          }}>
                                          <Iconify icon="eva:edit-outline" sx={{ mr: 1 }} />
                                          Editar agravo(s)
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => {
                                            setOpenModalDeleteClaim(true);
                                          }}>
                                          <Iconify icon="eva:trash-outline" sx={{ mr: 1 }} />
                                          Excluir agravo(s)
                                        </MenuItem>
                                      </Menu>
                                    </React.Fragment>
                                  )}
                                </PopupState>
                              )}
                            {infoState.id_type_user === 1 &&
                              // infoState.id_profile !== 2 &&
                              infoState.analisemedica === 'Sim' &&
                              infoState.incluiagravo === 'Sim' &&
                              (infosClients.statusvenda === 'Realizar entrevista' ||
                                infosClients.statusvenda === 'Aguardando CPT(s)' ||
                                infosClients.statusvenda === 'Analisar entrevista' ||
                                infosClients.statusvenda === 'Aguardando cliente') && (
                                <Button
                                  variant="contained"
                                  color="warning"
                                  onClick={downloadDeclarationOfHealthPdf}
                                  sx={{ ml: 1 }}
                                  startIcon={<Iconify icon="eva:alert-circle-outline" />}>
                                  Apontamentos
                                </Button>
                              )}
                          </Stack>
                        </>
                      )}
                      <DataGrid
                        dataSource={infosClientsHealth.map((item) => {
                          const key = item.flag
                            ? `titular_${infosClients.id}`
                            : `dependente_${item.id}`;
                          return {
                            ...item,
                            imc: imcCalculado[key] || null
                          };
                        })}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={selectedRow}>
                        <Selection mode="single" />
                        <Column dataField="id" caption="Id" />
                        <Column dataField="nome" caption="Nome" />
                        {!isMobile && <Column dataField="cpf_cnpj" caption="Cpf" />}
                        {!isMobile && <Column dataField="tpbenef" caption="Tipo de beneficiário" />}
                        {!isMobile && <Column dataField="email" caption="Email" />}
                        {infosClients.id_type_client === 2 && (
                          <Column
                            dataField="id_tit"
                            caption="Id. titular"
                            cellRender={(data) => <RenderidTit data={data} />}
                          />
                        )}
                        {infoState.tipooperacao !== 'Cartão' &&
                          infoState.tipooperacao !== 'Odonto' && (
                            <Column
                              dataField="completedhealthdeclaration"
                              caption="Declaração preenchida"
                              cellRender={(data) => <RenderHealth data={data} />}
                            />
                          )}
                        {infoState.id_type_user === 1 && infoState.incluiagravo === 'Sim' && (
                          <Column
                            dataField="claim"
                            caption="Beneficiário agravado"
                            cellRender={(data) => <RenderClaim data={data} />}
                          />
                        )}
                        {infoState.imc_declinio && (
                          <Column
                            dataField="imc"
                            caption="IMC"
                            dataType="number"
                            format="fixedPoint"
                            precision={2}
                            cellRender={(data) => {
                              if (!data.value || isNaN(data.value)) {
                                return <span>-</span>;
                              }
                              const cor = getCorIMC(data.value);
                              if (!cor) {
                                return <span>-</span>;
                              }
                              return (
                                <Chip
                                  label={data.value.toFixed(2)}
                                  size="small"
                                  variant="contained"
                                  sx={{
                                    backgroundColor: cor,
                                    color: '#FFF',
                                    fontWeight: 'medium'
                                  }}
                                />
                              );
                            }}
                          />
                        )}
                        <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={30} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="6" variant="fullWidth">
                      <Stack direction="row" alignItems="center" justifyContent="start">
                        <Grid container>
                          <Grid item xs={12}>
                            <CustomInfosForm>
                              Adicionar, visualizar e/ou remover documentos
                            </CustomInfosForm>
                          </Grid>
                        </Grid>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ mb: 1 }}>
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={downloadDocuments}
                              sx={{ mr: 1 }}
                              disabled={rowsSelectedDownload.length ? false : true}
                              startIcon={<Iconify icon="eva:cloud-download-outline" />}>
                              Download
                            </Button>
                          </>
                        </Stack>
                      </Stack>
                      <DataGrid
                        dataSource={documentsDownload}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={selectRowsDownload}
                        noDataText={'Não foram documentos para baixar'}>
                        <Selection mode="multiple" />
                        <Column dataField="nome" caption="Nome documento" />
                        <SearchPanel visible={true} width={250} placeholder="Procurar..." />
                        <GroupPanel
                          visible={true}
                          emptyPanelText="Arraste as colunas aqui para agrupar"
                        />
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={5} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                  </TabContext>
                </Box>
              )}
              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  disabled={
                    (infoState.id_type_user === 2 && infosClients.statusvenda !== 'Aberta') ||
                    infosClients.statusvenda === 'Aprovada' ||
                    (infosClients.statusvenda !== 'Negada' &&
                      infosClients.statusvenda !== 'Cancelada pelo proponente' &&
                      countSigningDocuments > 0) ||
                    (infosClients.allow_additive === 'S' ? true : false) ||
                    (infoState.controlaregiao === 'Sim' && !infosClients.id_regiao) ||
                    infoState.id_profile === 4
                  }
                  startIcon={<Iconify icon="eva:save-fill" />}
                  sx={{ mr: 2 }}>
                  {infosClients.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/clients"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid>
        </Card>
        {/* Modal de Upload de Documentos */}
        <BootstrapDialog
          onClose={() => setOpenModalDocumentUpload(false)}
          aria-labelledby="document-upload-dialog-title"
          open={openModalDocumentUpload}
          maxWidth="lg"
          fullWidth>
          <BootstrapDialogTitle
            id="document-upload-dialog-title"
            onClose={() => setOpenModalDocumentUpload(false)}>
            Upload de Documentos
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Box sx={{ p: 2 }}>
              <CustomInfosForm>
                Selecione os benefícios e faça upload dos documentos obrigatórios:
              </CustomInfosForm>
              {/* Seletor de Beneficiários */}
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={12}>
                  <InputLabel id="beneficiary-select-label" sx={{ fontSize: '13px', mb: 1 }}>
                    Beneficiário *
                  </InputLabel>
                  <Select
                    labelId="beneficiary-select-label"
                    fullWidth
                    size="small"
                    value={selectedBeneficiaries.length > 0 ? selectedBeneficiaries[0].id : ''}
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      const selectedBeneficiary = allBeneficiaries.find((b) => b.id === selectedId);
                      setSelectedBeneficiaries(selectedBeneficiary ? [selectedBeneficiary] : []);
                    }}
                    displayEmpty>
                    <MenuItem value="" disabled>
                      Selecione um beneficiário
                    </MenuItem>
                    {[...allBeneficiaries]
                      .sort((a, b) => {
                        // Para empresarial, colocar titular (empresa) primeiro
                        if (infosClients.id_type_client === 2) {
                          if (a.titbenef === 'S' && b.titbenef !== 'S') return -1;
                          if (a.titbenef !== 'S' && b.titbenef === 'S') return 1;
                        }
                        return 0;
                      })
                      .map((beneficiary) => {
                        let tipoLabel = beneficiary.parentesco;
                        if (infosClients.titbenef === 'N' && infosClients.id_type_client === 1) {
                          if (beneficiary.cpf === infosClients.cpf_cnpj) {
                            tipoLabel = 'Responsável Jurídico';
                          } else if (beneficiary.parentesco === null) {
                            tipoLabel = 'Titular';
                          }
                        } else if (infosClients.id_type_client === 2) {
                          if (beneficiary.cpf === infosClients.cpf_cnpj) {
                            tipoLabel = 'Empresa';
                          } else if (beneficiary.parentesco === null) {
                            tipoLabel = 'Titular';
                          }
                        }
                        if (
                          infosClients.id_type_client === 2 &&
                          beneficiary.cpf === infosClients.cpf_cnpj
                        ) {
                          return (
                            <MenuItem key={beneficiary.id} value={beneficiary.id}>
                              <span style={{ textTransform: 'uppercase' }}>{beneficiary.nome}</span>{' '}
                              - CNPJ: {beneficiary.cpf || beneficiary.cpf_cnpj || '-'} ({tipoLabel})
                            </MenuItem>
                          );
                        }
                        return (
                          <MenuItem key={beneficiary.id} value={beneficiary.id}>
                            <span style={{ textTransform: 'uppercase' }}>{beneficiary.nome}</span> -
                            CPF: {beneficiary.cpf || beneficiary.cpf_cnpj || '-'} ({tipoLabel})
                          </MenuItem>
                        );
                      })}
                  </Select>
                </Grid>
              </Grid>
              {/* Cards de Documentos Obrigatórios */}
              <Grid container spacing={3}>
                {(() => {
                  // Normalizador que remove acentos, espaços e caracteres especiais
                  const normalizeStr = (str) =>
                    str
                      ? String(str)
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                          .toLowerCase()
                          .replace(/[^a-z0-9]/g, '')
                      : '';

                  const hasDocs = Array.isArray(infosDocs) && infosDocs.length > 0;

                  // Identificação do Beneficiário Selecionado no Dropdown
                  const selectedBeneficiary =
                    selectedBeneficiaries.length > 0 ? selectedBeneficiaries[0] : null;
                  const selectedCpf = selectedBeneficiary
                    ? normalizeStr(selectedBeneficiary.cpf || selectedBeneficiary.cpf_cnpj)
                    : '';
                  const clientCpf = normalizeStr(infosClients?.cpf_cnpj);

                  // Validação da Empresa (PJ)
                  const isEmpresa =
                    infosClients?.id_type_client === 2 &&
                    selectedCpf !== '' &&
                    selectedCpf === clientCpf;

                  // Validação do Responsável Jurídico
                  const isRespJuridico =
                    infosClients?.id_type_client === 1 &&
                    infosClients?.titbenef === 'N' &&
                    selectedCpf !== '' &&
                    selectedCpf === clientCpf;

                  // É um Beneficiário Comum (Titular / Dependente) se NÃO for empresa nem Responsável Jurídico
                  const isBeneficiarioComum = !isEmpresa && !isRespJuridico;

                  // --- CENÁRIO 1: Sem documentos configurados na API ---
                  if (!hasDocs) {
                    if (company !== 'higiasaude') {
                      return (
                        <>
                          {!isEmpresa && (
                            <Grid item xs={12} md={6}>
                              <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                                <Typography
                                  variant="h6"
                                  sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                                  RG/CNH
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                                  Documento opcional (2 arquivos)
                                </Typography>
                                <DropzoneArea
                                  acceptedFiles={['image/*', 'application/pdf']}
                                  maxFileSize={10000000}
                                  onChange={(files) => handleDocumentUpload(files, 'rg_cnh')}
                                  dropzoneText="Arraste os documentos aqui ou clique para selecionar"
                                  fullWidth={true}
                                  showAlerts={false}
                                  filesLimit={2}
                                  showPreviewsInDropzone={true}
                                  getFileLimitExceedMessage={() =>
                                    NotificationManager.warning(
                                      'Apenas 2 arquivos permitidos',
                                      'Atenção'
                                    )
                                  }
                                />
                              </Card>
                            </Grid>
                          )}

                          {!isEmpresa && (
                            <Grid item xs={12} md={6}>
                              <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                                <Typography
                                  variant="h6"
                                  sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                                  Comprovante de Residência
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                                  Documento opcional (1 arquivo)
                                </Typography>
                                <DropzoneArea
                                  acceptedFiles={['image/*', 'application/pdf']}
                                  maxFileSize={10000000}
                                  onChange={(files) =>
                                    handleDocumentUpload(files, 'comprovante_residencia')
                                  }
                                  dropzoneText="Arraste o documento aqui ou clique para selecionar"
                                  fullWidth={true}
                                  showAlerts={false}
                                  filesLimit={1}
                                  showPreviewsInDropzone={true}
                                  getFileLimitExceedMessage={() =>
                                    NotificationManager.warning(
                                      'Apenas 1 arquivo permitido',
                                      'Atenção'
                                    )
                                  }
                                />
                              </Card>
                            </Grid>
                          )}

                          {!isEmpresa && (
                            <Grid item xs={12} md={6}>
                              <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                                <Typography
                                  variant="h6"
                                  sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                                  Cartão Nacional de Saúde
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                                  Documento opcional (1 arquivo)
                                </Typography>
                                <DropzoneArea
                                  acceptedFiles={['image/*', 'application/pdf']}
                                  maxFileSize={10000000}
                                  onChange={(files) => handleDocumentUpload(files, 'cartao_saude')}
                                  dropzoneText="Arraste o documento aqui ou clique para selecionar"
                                  fullWidth={true}
                                  showAlerts={false}
                                  filesLimit={1}
                                  showPreviewsInDropzone={true}
                                  getFileLimitExceedMessage={() =>
                                    NotificationManager.warning(
                                      'Apenas 1 arquivo permitido',
                                      'Atenção'
                                    )
                                  }
                                />
                              </Card>
                            </Grid>
                          )}

                          <Grid item xs={12} md={isEmpresa ? 12 : 6}>
                            <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                              <Typography
                                variant="h6"
                                sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                                Documentos Diversos
                              </Typography>
                              <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                                Documentos opcionais (múltiplos arquivos)
                              </Typography>
                              <DropzoneArea
                                acceptedFiles={['image/*', 'application/pdf']}
                                maxFileSize={10000000}
                                onChange={(files) =>
                                  handleDocumentUpload(files, 'documentos_diversos')
                                }
                                dropzoneText="Arraste os documentos aqui ou clique para selecionar"
                                fullWidth={true}
                                showAlerts={false}
                                filesLimit={10}
                                showPreviewsInDropzone={true}
                                getFileLimitExceedMessage={(filesLimit) =>
                                  NotificationManager.warning(
                                    `Máximo de ${filesLimit} arquivos`,
                                    'Atenção'
                                  )
                                }
                              />
                            </Card>
                          </Grid>
                        </>
                      );
                    } else {
                      return (
                        <Grid item xs={12} md={12}>
                          <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                            <Typography
                              variant="h6"
                              sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                              Documentos Diversos
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                              Documentos opcionais (múltiplos arquivos)
                            </Typography>
                            <DropzoneArea
                              acceptedFiles={['image/*', 'application/pdf']}
                              maxFileSize={10000000}
                              onChange={(files) =>
                                handleDocumentUpload(files, 'documentos_diversos')
                              }
                              dropzoneText="Arraste os documentos aqui ou clique para selecionar"
                              fullWidth={true}
                              showAlerts={false}
                              filesLimit={10}
                              showPreviewsInDropzone={true}
                              getFileLimitExceedMessage={(filesLimit) =>
                                NotificationManager.warning(
                                  `Máximo de ${filesLimit} arquivos`,
                                  'Atenção'
                                )
                              }
                            />
                          </Card>
                        </Grid>
                      );
                    }
                  }

                  // --- CENÁRIO 2: Possui infosDocs da API ---
                  const filteredDocs = infosDocs.filter((doc) => {
                    // 1. Validação por Tipo de Contratação (tpcontrat)
                    const clientTpContrat = normalizeStr(
                      infosClients?.tpcontrat ||
                        infosClients?.id_tpcontrat ||
                        infosClients?.tipo_contratacao
                    );
                    const docTpContrat = normalizeStr(doc.tpcontrat);

                    if (docTpContrat && clientTpContrat) {
                      if (docTpContrat !== clientTpContrat) {
                        return false;
                      }
                    }

                    // 2. Validação do Formato (Higia Saúde)
                    if (company === 'higiasaude' && doc.formato && infosClients?.formato) {
                      if (normalizeStr(doc.formato) !== normalizeStr(infosClients.formato)) {
                        return false;
                      }
                    }

                    // 3. Validação por Direção (doc.direcao)
                    const docDirecao = normalizeStr(doc.direcao);

                    // Direção do tipo EMPRESA
                    if (docDirecao === 'empresa') {
                      return isEmpresa;
                    }

                    // Direção do tipo RESPONSÁVEL JURÍDICO (Trata "Responsável juridico", "responsavel_juridico", etc.)
                    if (docDirecao.includes('responsavel')) {
                      return isRespJuridico;
                    }

                    // Direção do tipo BENEFICIÁRIO
                    if (docDirecao === 'beneficiario') {
                      return isBeneficiarioComum;
                    }

                    return true;
                  });

                  // Se nenhum documento passou pelo filtro
                  if (filteredDocs.length === 0) {
                    return (
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          align="center"
                          sx={{ py: 3 }}>
                          Nenhum documento necessário para o selecionado.
                        </Typography>
                      </Grid>
                    );
                  }

                  // Renderização dos cards dos documentos
                  return filteredDocs.map((doc) => {
                    const isDiversos = doc.nome?.toLowerCase().includes('documentos diversos');
                    const mdValue = isDiversos && filteredDocs.length === 1 ? 12 : 6;

                    return (
                      <Grid item xs={12} md={mdValue} key={doc.id || `${doc.nome}-${doc.direcao}`}>
                        <Card sx={{ p: 2, border: '2px solid #e0e0e0', height: '100%' }}>
                          <Typography
                            variant="h6"
                            sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                            {doc.nome}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                            {doc.obrigatorio ? 'Documento obrigatório' : 'Documento opcional'} (
                            {doc.qtde} {doc.qtde === 1 ? 'arquivo' : 'arquivos'})
                          </Typography>
                          <DropzoneArea
                            acceptedFiles={['image/*', 'application/pdf']}
                            maxFileSize={10000000}
                            onChange={(files) =>
                              handleDocumentUpload(files, doc.nome ? doc.nome : 'documento')
                            }
                            dropzoneText="Arraste os documentos aqui ou clique para selecionar"
                            fullWidth={true}
                            showAlerts={false}
                            filesLimit={doc.qtde || 1}
                            showPreviewsInDropzone={true}
                            getFileLimitExceedMessage={(limit) =>
                              NotificationManager.warning(`Máximo de ${limit} arquivos`, 'Atenção')
                            }
                          />
                        </Card>
                      </Grid>
                    );
                  });
                })()}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleSubmitDocuments}
              variant="contained"
              color="success"
              sx={{ textDecoration: 'none' }}
              startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
              Enviar
            </Button>
            <Button
              onClick={() => setOpenModalDocumentUpload(false)}
              variant="contained"
              color="error"
              startIcon={<Iconify icon="eva:close-circle-fill" />}>
              Cancelar
            </Button>
          </DialogActions>
        </BootstrapDialog>
        {/* Modal de importação de layout */}
        <BootstrapDialog
          onClose={() => setOpenModalImportLayout(false)}
          aria-labelledby="import-layout-dialog-title"
          open={openModalImportLayout}
          maxWidth="lg"
          fullWidth>
          <BootstrapDialogTitle
            id="import-layout-dialog-title"
            onClose={() => setOpenModalImportLayout(false)}>
            Importação de layout
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Box sx={{ p: 2 }}>
              <CustomInfosForm>
                Selecione o arquivo (xlsx e/ou csv) e faça a importação dos beneficiários
              </CustomInfosForm>
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={12} md={12}>
                  <Card sx={{ p: 2, border: '2px solid #e0e0e0' }}>
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
                      Layout de importação (xlsx e/ou csv)
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                      Realize a importaçaõ dos beneficiários através do layout disponibilizado. O
                      arquivo deve conter as colunas obrigatórias e seguir o padrão de formatação
                      especificado.
                    </Typography>
                    <DropzoneArea
                      acceptedFiles={[
                        '.csv',
                        '.xlsx',
                        'text/csv',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                      ]}
                      maxFileSize={10000000}
                      onChange={(files) => handleDocumentUpload(files, 'documentos_diversos')}
                      dropzoneText="Arraste os documentos aqui ou clique para selecionar"
                      fullWidth={true}
                      showAlerts={false}
                      filesLimit={10}
                      showPreviewsInDropzone={true}
                      getFileLimitExceedMessage={(filesLimit) =>
                        NotificationManager.warning(`Máximo de ${filesLimit} arquivos`, 'Atenção')
                      }
                    />
                  </Card>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleImportXls}
              variant="contained"
              color="success"
              sx={{ textDecoration: 'none' }}
              startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
              Importar
            </Button>
            <Button
              onClick={() => setOpenModalImportLayout(false)}
              variant="contained"
              color="error"
              startIcon={<Iconify icon="eva:close-circle-fill" />}>
              Cancelar
            </Button>
          </DialogActions>
        </BootstrapDialog>
        {/* Modal de Documentos Pendentes */}
        <BootstrapDialog
          open={openModalPending}
          onClose={handleCloseModal}
          maxWidth="sm"
          fullWidth
          aria-labelledby="modal-pending-docs-title">
          <DialogTitle
            id="modal-pending-docs-title"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              bgcolor: 'error.main',
              color: 'warning.contrastText',
              fontWeight: 'bold'
            }}>
            <ErrorOutlineIcon color="warning" />
            Atenção: Documentos obrigatórios pendentes
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              Para prosseguir, é necessário anexar os documentos exigidos para cada
              beneficiário/empresa:
            </Typography>
            <List disablePadding>
              {pendingDocsList.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem sx={{ py: 1.5, px: 1 }}>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <DescriptionIcon color="error" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                          {item.pessoa}
                        </Typography>
                      }
                      secondary={
                        <Typography variant="body2" color="text.secondary">
                          <strong>Documento:</strong> {item.docNome} — enviado(s){' '}
                          <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                            {item.enviados}
                          </span>{' '}
                          de <strong>{item.esperados}</strong> necessário(s).
                        </Typography>
                      }
                    />
                  </ListItem>
                  {index < pendingDocsList.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
            </List>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleCloseModal} variant="contained" color="error">
              Fechar
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </>
    </RenderPage>
  );
};

export default AddEditClients;
